<template>
<div id="page_consulta_tigie">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="TIGIE" class="elevation-1 px-5 py-3">
                    <v-card-actions style="margin-top:-50px">

                        <v-spacer></v-spacer>

                        <v-btn fab dark x-small color="blue" href="https://www.snice.gob.mx/cs/avi/snice/nuevaligie.instrumentacion.html" target="_blank" title="DOF LIGIE última reforma" v-tippy>
                            <v-icon dark>mdi-web</v-icon>
                        </v-btn>

                        <v-btn fab dark x-small color="orange" @click.native="downloadURL('acuerdo_metodologia.pdf');" title="Acuerdo por el que se establece la metodologia para la creación y modificación de los numeros de identificación comercial" v-tippy>
                            <v-icon dark>mdi-file</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>

                        <v-tabs grow style="margin-bottom: 30px;">
                            <v-tabs-slider color="primary"></v-tabs-slider>


                            <v-tab key="con22">
                                <v-card-title><b>Consulta TIGIE</b></v-card-title>
                            </v-tab>
                            <v-tab key="rep">
                                <v-card-title><b>Reportes</b></v-card-title>
                            </v-tab>


                            <v-tab-item key="con22" style="margin: 30px;">

                                <v-form ref="form3" lazy-validation>

                                    <v-row>
                                        <v-col cols="3">
                                            <v-text-field clearable clear-icon="mdi-close-circle-outline" label="Número de Fracción" type="text" @keydown.enter.prevent="buscar22()" v-model="search22" :rules="[rules.required]" maxlength="15"></v-text-field>
                                        </v-col>
                                        <v-col cols="3" style="margin-top:20px;">
                                            <v-btn color="primary" small @click.native="buscar22">
                                                <v-icon>search</v-icon>Consultar Fracción
                                            </v-btn>

                                        </v-col>
                                        <v-col cols="3">

                                            <v-autocomplete v-model="capituloNota" :items="lista_categorias" :return-object="false" item-text="name" item-value="id" label="Capitulo">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="3" style="margin-top:20px;">
                                            <v-btn color="blue" small @click.native="consultaNotas">
                                                <v-icon>search</v-icon>Consultar Notas Nacionales
                                            </v-btn>

                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-spacer></v-spacer>

                                <div v-if="search22 !='' && nueva_tabla22['fracciones'] != undefined">
                                    <v-card-text v-if="nueva_tabla22['fracciones'] != undefined && nueva_tabla22['fracciones'].length > 0">
                                        <v-client-table :data="nueva_tabla22['fracciones'].slice(0, nueva_tabla22['fracciones'].length -1)" :columns="columns_capitulo" :options="capitulo_options" class="footer-hide">
                                        </v-client-table>
                                    </v-card-text>
                                    <v-card-text v-if="nueva_tabla22['Fraccion'] != undefined">
                                        <table v-if="nueva_tabla22['Fraccion'] != undefined" class="table table-bordered table-striped table-condensed">
                                            <tbody>
                                                <tr>
                                                    <td> <b style="text-align:left;">FRACCIÓN</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['Fraccion']}}</span></td>
                                                    <td> <b style="text-align:left;">FRACCIÓN CON PUNTO</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['FraccionPunto']}}</span></td>
                                                </tr>
                                                <tr>
                                                    <td> <b style="text-align:left;">DESCRIPCIÓN</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['Descripcion']}}</span></td>
                                                    <td> </td>
                                                    <td> </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <p />
                                                    </td>
                                                    <td> </td>
                                                    <td> </td>
                                                    <td> </td>
                                                </tr>
                                                <tr>
                                                    <td> <b style="text-align:left;">UM CLAVE</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['UMClave']}}</span></td>
                                                    <td> <b style="text-align:left;">UM ABREVIACION</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['UMAbreviacion']}}</span></td>
                                                </tr>
                                                <tr>
                                                    <td> <b style="text-align:left;">ADV IMPO NUM</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['AdvImpoNum']}}</span></td>
                                                    <td> <b style="text-align:left;">ADV EXPO NUM</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['AdvExpoNum']}}</span></td>
                                                </tr>
                                                <tr>
                                                    <td> <b style="text-align:left;">ADV IMPO TXT</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['AdvImpoTxt']}}</span></td>
                                                    <td> <b style="text-align:left;">ADV EXPO TXT</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['AdvExpoTxt']}}</span></td>
                                                </tr>
                                                <tr>
                                                    <td> <b style="text-align:left;">NICO</b></td>
                                                    <td> <span style="text-align:left;">{{nueva_tabla22['Fraccion'][0]['NICO']}}</span></td>
                                                    <td> <b style="text-align:left;"></b></td>
                                                    <td> <span style="text-align:left;"></span></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </v-card-text>
                                    <v-tabs v-if="nueva_tabla22['Fraccion'] != undefined">
                                        <v-tabs-slider color="primary"></v-tabs-slider>

                                        <v-tab :key="'codigo2'">
                                            <v-card-title><b>Marco Normativo</b></v-card-title>
                                        </v-tab>
                                        <v-tab :key="'ficha2'">
                                            <v-card-title><b>Ficha Informativa</b></v-card-title>
                                        </v-tab>
                                        <v-tab-item :key="'codigo2'" style="margin: 30px;">
                                            <div>

                                                <!--      <v-card v-if="ws_columnas_nueva_tabla['bIEPS'] != undefined && ws_columnas_nueva_tabla['bIEPS'].length>0" style="margin:0; padding:0;">
                    <h5 style="color:#0E4D78"><b>OTRAS CONTRIBUCIONES DISTINTAS AL AD VALOREM</b></h5>
                    <v-card-title>
                        <b>IEPS</b>
                    </v-card-title>
                    <v-card-text>

                        <table class="table table-bordered table-striped table-condensed">
                            <tbody>

                                <tr v-for="(h, i) in ws_columnas_nueva_tabla['bIEPS']" :key="'h__' +i">
                                    <td v-if="h!='SYSID' && h!='DOF' && h!='FRACCION'"> <b style="text-align:left;">{{h}}</b></td>
                                    <td v-if="h!='SYSID' && h!='DOF' && h!='FRACCION'"> <span style="text-align:left;">{{nueva_tabla['bIEPS'][0][h]}}</span></td>
                                </tr>

                            </tbody>
                        </table>
                    </v-card-text>
                </v-card> -->

                                                <v-card v-if="ws_columnas_nueva_tabla22['regulaciones'] != undefined &&  nueva_tabla22['regulaciones'].length>0" style="margin:0; padding:0;">

                                                    <v-card-text>
                                                        <h5 style="color:#0E4D78"><b>REGULACIONES Y RESTRICCIONES</b></h5>

                                                        <table v-if="nueva_tabla22['regulaciones'].length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(h, ixh) in ws_columnas_nueva_tabla22['regulaciones']" :key="'h__' + ixh" v-show="h!='SYSID'">
                                                                        <span style="text-align:left;">{{h}}</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="VueTables__row " v-for="(renglon, index) in nueva_tabla22['regulaciones']" :key="'r__' + index ">
                                                                    <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='SYSID'">

                                                                        <span v-if="i!='Documentos' " style="text-align:left;">{{d}}</span>
                                                                        <v-btn v-if="i=='Documentos' && d != null" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/docs/regulaciones/'+ d.split('&')[0].replace('rtf','pdf')" :title="d.split('&')[0].replace('rtf','pdf')" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                        <v-btn v-if="i=='Documentos' && d != null && d.split('&')[1] != undefined" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/docs/regulaciones/'+ d.split('&')[1].replace('rtf','pdf')" :title="d.split('&')[1].replace('rtf','pdf')" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>

                                                <v-card v-if="nueva_tabla22['reit'] != undefined && nueva_tabla22['reit'].length>0" style="margin:0; padding:0;">
                                                    <v-card-title>
                                                        <b>RESTRICCIONES A LA IMPORTACÓN TEMPORAL</b>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table class="table table-bordered table-striped table-condensed">
                                                            <tbody>

                                                                <tr v-for="(h, i) in ws_columnas_nueva_tabla22['reit']" :key="'h__' +i">
                                                                    <td v-if="h!='SYSID' && h!='DOF'"> <b style="text-align:left;">{{h}}</b></td>
                                                                    <td v-if="h!='SYSID' && h!='DOF'"> <span style="text-align:left;">{{nueva_tabla22['reit'][0][h]}}</span></td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>

                                                <!--  <v-card v-if="nueva_tabla['bPreciosEstimados'].length>0" style="margin:0; padding:0;">
                    <v-card-title>
                        <b>PRECIOS ESTIMADOS</b>
                    </v-card-title>
                    <v-card-text>
                        <table class="table table-bordered table-striped table-condensed">
                            <tbody>

                                <tr v-for="(h, i) in ws_columnas_nueva_tabla['bPreciosEstimados']" :key="'h__' +i">
                                    <td v-if="h!='SYSID' && h!='DOF'"> <b style="text-align:left;">{{h}}</b></td>
                                    <td v-if="h!='SYSID' && h!='DOF'"> <span style="text-align:left;">{{nueva_tabla['bPreciosEstimados'][0][h]}}</span></td>
                                </tr>

                            </tbody>
                        </table>
                    </v-card-text>
                </v-card> -->

                                                <v-card v-if="ws_columnas_nueva_tabla22['rcg2'] != undefined &&  nueva_tabla22['rcg2'].length>0" style="margin:0; padding:0;">
                                                    <v-card-title>
                                                        <b>ANEXOS REGLAS</b>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table v-if="ws_columnas_nueva_tabla22['rcg2'].length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(h, ixh) in ws_columnas_nueva_tabla22['rcg2']" :key="'h__' + ixh" v-show=" h!='SYSID'">
                                                                        <span style="text-align:left;">{{h}}</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="VueTables__row " v-for="(renglon, index) in nueva_tabla22['rcg2']" :key="'r__' + index ">
                                                                    <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='SYSID'">
                                                                        <span style="text-align:left;">{{d}}</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>

                                                <v-card v-if="ws_columnas_nueva_tabla22['tlcs'] != undefined &&  nueva_tabla22['tlcs'].length>0" style="margin:0; padding:0;">
                                                    <h5 style="color:#0E4D78"><b>TRATADOS</b></h5>
                                                    <v-card-title>
                                                        <b>TLC</b>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table v-if="nueva_tabla22['tlcs'].length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(h, ixh) in ws_columnas_nueva_tabla22['tlcs']" :key="'h__' + ixh" v-show="h!='PaisL'">
                                                                        <span style="text-align:left;">{{h}}</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="VueTables__row " v-for="(renglon, index) in nueva_tabla22['tlcs']" :key="'r__' + index ">
                                                                    <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='PaisL' ">
                                                                        <span v-show="i!='Documentos'" style="text-align:left;">{{d}}</span>
                                                                        <!--  <v-btn  v-show="d != null &&  i=='Documentos'" icon small fab dark color="black" :href="getfile(d.split('|')[0])" title="Documentos" target="_blank" v-tippy>
                                            <v-icon>mdi-file</v-icon>
                                            </v-btn> -->
                                                                        <v-btn v-if="i=='Documentos' && d != null" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/'+ d.split('|')[0].replace('rtf','pdf')" :title="d.split('|')[0].replace('rtf','pdf')" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                        <v-btn v-if="i=='Documentos' && d != null && d.split('|')[1] != undefined" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/'+ d.split('|')[1].replace('rtf','pdf')" :title="d.split('|')[1].replace('rtf','pdf')" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>

                                                <v-card v-if="ws_columnas_nueva_tabla22['tipac'] != undefined &&   nueva_tabla22['tipac'].length>0" style="margin:0; padding:0;">
                                                    <v-card-title>
                                                        <b>TIPAT</b>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table v-if="nueva_tabla22['tipac'].length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(h, ixh) in ws_columnas_nueva_tabla22['tipac']" :key="'h__' + ixh" v-show="h!='PaisL' ">
                                                                        <span style="text-align:left;">{{h}}</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="VueTables__row " v-for="(renglon, index) in nueva_tabla22['tipac']" :key="'r__' + index ">
                                                                    <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='PaisL' ">
                                                                        <span v-show="i!='Documentos'" style="text-align:left;">{{d}}</span>
                                                                        <!--  <v-btn  v-show="d != null &&  i=='Documentos'" icon small fab dark color="black" :href="getfile(d.split('|')[0])" title="Documentos" target="_blank" v-tippy>
                                            <v-icon>mdi-file</v-icon>
                                            </v-btn> -->
                                                                        <v-btn v-if="i=='Documentos' && d != null" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/'+ d.split('|')[0].replace('rtf','pdf')" :title="d.split('|')[0].replace('rtf','pdf')" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                        <v-btn v-if="i=='Documentos' && d != null && d.split('|')[1] != undefined" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/'+ d.split('|')[1].replace('rtf','pdf')" :title="d.split('|')[1].replace('rtf','pdf')" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                                <v-card v-if="ws_columnas_nueva_tabla22['aladi2'] != undefined &&   nueva_tabla22['aladi2'].length>0" style="margin:0; padding:0;">
                                                    <v-card-title>
                                                        <b>ALADI</b>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table v-if="nueva_tabla22['aladi2'].length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(h, ixh) in ws_columnas_nueva_tabla22['aladi2']" :key="'h__' + ixh" v-show="h!='PaisL' && h!='SYSID'">
                                                                        <span style="text-align:left;">{{h}}</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="VueTables__row " v-for="(renglon, index) in nueva_tabla22['aladi2']" :key="'r__' + index ">
                                                                    <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='PaisL' && i!='SYSID'">
                                                                        <span style="text-align:left;">{{d}}</span>
                                                                        <v-btn v-show="d != null &&  i=='Acuerdo'" icon small fab dark color="black" :href="'https://hts.gsmartcode.com/docs/aladi/' + d + '.pdf'" title="Documento" target="_blank" v-tippy>
                                                                            <v-icon>mdi-file</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </div>

                                        </v-tab-item>
                                        <v-tab-item :key="'ficha2'" style="margin: 30px;">

                                            <v-card v-if="ws_columnas_nueva_tabla22['historicofracciones'] != undefined && nueva_tabla22['historicofracciones'] != undefined && nueva_tabla22['historicofracciones'].length>0" style="margin:0; padding:0;">
                                                <v-card-title>
                                                    <b>HISTORICO DE CAMBIOS AD VALOREM</b>
                                                </v-card-title>
                                                <v-card-text>
                                                    <table v-if="nueva_tabla22['historicofracciones'].length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th v-for="(h, ixh) in ws_columnas_nueva_tabla22['historicofracciones']" :key="'h__' + ixh" v-show="h!='SYSID'">
                                                                    <span style="text-align:left;">{{h}}</span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="VueTables__row " v-for="(renglon, index) in nueva_tabla22['historicofracciones']" :key="'r__' + index ">
                                                                <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='SYSID'">
                                                                    <span style="text-align:left;">{{d}}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </v-card-text>
                                            </v-card>

                                        </v-tab-item>
                                    </v-tabs>
                                </div>
                                <div v-if="capituloNota !='' ">
                                    <br /><br /><br />
                                    <v-card style="margin:0; padding:0;">
                                        <h5 style="color:#0E4D78"><b>NOTAS NACIONALES</b></h5>

                                        <v-card-text>
                                            <table v-if="datosCapituloNota.length>0" class="VueTables__table table table-striped table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th v-for="(h, ixh) in columnasCapituloNota" :key="'h__' + ixh" v-show="h!='Capitulo' &&  h!='SysID'">
                                                            <span style="text-align:left;">{{h}}</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="VueTables__row " v-for="(renglon, index) in datosCapituloNota" :key="'r__' + index ">
                                                        <td v-for="(d, i) in renglon" :key="'c__' + i " v-show="i!='Capitulo' && i!='SysID'">

                                                            <div style="padding:10px; background-color:white; white-space: pre-wrap;">{{d}}</div>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-tab-item>
                            <v-tab-item key="rep" style="margin: 30px;">
                                <v-form ref="reportes_form">
                                <v-row row wrap>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true"
                                        :return-object="false" @change="cambiafechas" item-text="text" item-value="id" label="Tipo de Reporte"
                                        :rules="[rules.required]">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col v-if="this.model.tipo_reporte == 2" sm="6" md="6" lg="6">

                                    </v-col>
                                </v-row>
                                <v-row row wrap>
                                    <v-col v-if="([2,4].includes(model.tipo_reporte))" sm="12" md="12" lg="12">

                                        <v-autocomplete v-model="model.capitulo"
                                            :items="lista_categorias" :return-object="false" item-text="name" item-value="id"
                                            label="Capitulo" :rules="[rules.required]">
                                        </v-autocomplete>

                                    </v-col>
                                    <v-col v-if="([2,4].includes(this.model.tipo_reporte))" sm="12" md="12" lg="12">

                                        <v-autocomplete v-model="model.opcion"
                                        :items="[{'opcion':'Fracciones relacionadas a la empresa / DS','value':'fracciones'},{'opcion':'Todo el capítulo','value':'capitulo'}]"
                                        :return-object="false" item-text="opcion" item-value="value"
                                        label="Filtrar" :rules="[rules.required]">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col v-if="model.tipo_reporte == 1" sm="12" md="6" lg="6">

                                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'">
                                                </v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu3 = false">
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col v-if="this.model.tipo_reporte == 1" sm="12" md="6" lg="6">
                                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary" max="2020-12-27" scrollable locale="es-mx" @input="menu4 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu4 = false">
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                    </v-col>
                                    <v-col v-if="this.model.tipo_reporte == 3" sm="12" md="6" lg="6">

                                    <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" min="2020-12-27" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'">
                                            </v-text-field>
                                        </template>

                                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu3 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    </v-col>
                                    <v-col v-if="this.model.tipo_reporte == 3" sm="12" md="6" lg="6">
                                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu4 = false">
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                    </v-col>
                                    <v-col v-if="this.model.tipo_reporte == 5" sm="12" md="6" lg="6">

                                    <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'">
                                            </v-text-field>
                                        </template>

                                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu3 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    </v-col>
                                    <v-col v-if="this.model.tipo_reporte == 5" sm="12" md="6" lg="6">
                                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu4 = false">
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                    </v-col>
                                </v-row>
                                </v-form>
                                <v-row>
                                    <v-spacer />
                                    <v-btn rounded color="success" @click="genera_reporte()">
                                        <v-icon>done</v-icon>Consultar
                                    </v-btn>
                                </v-row>
                                <p />
                                <pre>
                                </pre>
                                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; padding-top:25px; padding-left:280px;  width:100%" v-if="data_table_m_impo.length>0"><b></b></div>
                                <div v-show="data_table_m_impo.length>0">
                                    <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:80px;  width:100%">

                                        <v-spacer />

                                        <exportar-excel v-if="data_table_m_impo.length>0 && visible_download2 && $refs.vuetableCapitulo != undefined" :data="filtrados"
                                            :exportFields="model.tipo_reporte == 2 ? data_table_m_impo_excel : data_table_m_impo_excel_22"
                                            :name="model.tipo_reporte == 2 ? 'CodigoEstadisticoCapitulo6taEnmienda.xlsx' : 'CodigoEstadisticoCapitulo7taEnmienda.xlsx'">
                                            <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                <v-icon dark>mdi-table</v-icon>
                                            </v-btn>
                                        </exportar-excel>


                                    </div>

                                    <v-client-table ref="vuetableCapitulo" :data="filtrados"
                                        :columns="columns_table_m_impo" :options="model.tipo_reporte == 2 ? table_m_impo_options : table_m_impo_options_22"
                                        class="elevation-2 pa-2" :key="actualizaTabla">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="row" class="divisor">

                                        </template>

                                        <template slot="capitulo" slot-scope="props">
                                            <span>{{props.row.fraccion!=null?props.row.capitulo:""}}</span>
                                        </template>
                                        <template slot="fraccion_enmienda" slot-scope="props">
                                            <span>{{props.row.fraccion!=null?props.row.fraccion_enmienda:""}}</span>
                                        </template>
                                        <template slot="fraccion" slot-scope="props">
                                            <span>{{props.row.fraccion!=null?props.row.fraccion:"->"}}</span>
                                        </template>
                                        <!--
                                            <div slot="capitulo" slot-scope="props" :class="{'divisor': props.row.fraccion!=null}" >{{props.row.capitulo}}</div> -->
                                    </v-client-table>
                                </div>
                                <v-tabs v-if="fracciones_cliente['importacion'] != undefined || fracciones_cliente['exportacion'] != undefined ">
                                    <v-tabs-slider color="primary"></v-tabs-slider>
                                    <v-tab key="impo" style="margin-left:-15px;">

                                        <b>IMPORTACIONES</b>

                                    </v-tab>
                                    <v-tab-item key="impo" style="margin-left:0px; margin-right:0px;">
                                        <v-card v-if="fracciones_cliente['importacion'].length>0" style="margin:0; padding:0;">

                                            <v-card-text>

                                                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">

                                                    <v-spacer />

                                                    <exportar-excel v-if="model.tipo_reporte == 1 && data_table_impo.length>0 && visible_download1" :data="data_table_impo" :exportFields="data_table_impo_excel" name="FraccionesRelacionadasImpo.xlsx">
                                                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                            <v-icon dark>mdi-table</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>
                                                    <exportar-excel v-if="model.tipo_reporte == 3 && data_table_impo.length>0 && visible_download1" :data="data_table_impo" :exportFields="data_table_impo_excel_22" name="FraccionesRelacionadasImpo.xlsx">
                                                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                            <v-icon dark>mdi-table</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>
                                                    <exportar-excel v-if="model.tipo_reporte == 5 && data_table_impo.length>0 && visible_download1" :data="data_table_impo" :exportFields="data_table_impo_excel_todas" name="FraccionesRelacionadasImpo.xlsx">
                                                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                            <v-icon dark>mdi-table</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>

                                                </div>
                                                <v-client-table v-if="model.tipo_reporte == 1" ref="v1" :data="data_table_impo" :columns="columns_table_impo" :options="table_impo_options" class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                    </template>
                                                </v-client-table>

                                                <v-client-table v-if="model.tipo_reporte == 3" ref="v1" :data="data_table_impo" :columns="columns_table_impo" :options="table_impo_options_22" class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                    </template>
                                                </v-client-table>

                                                <v-client-table v-if="model.tipo_reporte == 5" ref="v1" :data="data_table_impo" :columns="columns_table_impo_todas" :options="table_impo_options_22_todas" class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                    </template>
                                                </v-client-table>

                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>

                                    <v-tab key="expo">

                                        <b>EXPORTACIONES</b>

                                    </v-tab>

                                    <v-tab-item key="expo" style="margin-left:0px; margin-right:0px;">
                                        <v-card v-if="fracciones_cliente['exportacion'] != undefined && fracciones_cliente['exportacion'].length>0">

                                            <v-card-text>

                                                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">

                                                    <v-spacer />

                                                    <exportar-excel v-if="model.tipo_reporte == 1 &&  data_table_expo.length>0 && visible_download1" :data="data_table_expo" :exportFields="data_table_expo_excel" name="FraccionesRelacionadasExpo.xlsx">
                                                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                            <v-icon dark>mdi-table</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>
                                                    <exportar-excel v-if="model.tipo_reporte == 3 &&  data_table_expo.length>0 && visible_download1" :data="data_table_expo" :exportFields="data_table_expo_excel_22" name="FraccionesRelacionadasExpo.xlsx">
                                                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                            <v-icon dark>mdi-table</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>
                                                    <exportar-excel v-if="model.tipo_reporte == 5 &&  data_table_expo.length>0 && visible_download1" :data="data_table_expo" :exportFields="data_table_impo_excel_todas" name="FraccionesRelacionadasExpo.xlsx">
                                                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                                            <v-icon dark>mdi-table</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>

                                                </div>
                                                <v-client-table v-if="model.tipo_reporte == 1" ref="v3" :data="data_table_expo" :columns="columns_table_expo" :options="table_expo_options" class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                    </template>
                                                </v-client-table>

                                                <v-client-table v-if="model.tipo_reporte == 3" ref="v3" :data="data_table_expo" :columns="columns_table_expo" :options="table_expo_options_22" class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                    </template>
                                                </v-client-table>

                                                <v-client-table v-if="model.tipo_reporte == 5" ref="v3" :data="data_table_expo" :columns="columns_table_impo_todas" :options="table_impo_options_22_todas" class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                    </template>
                                                </v-client-table>

                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs>

                                <pre>

                                </pre>
                            </v-tab-item>
                        </v-tabs>

                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
    <pre>

                      </pre>
</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import moment, {
    relativeTimeRounding
} from "moment";
import {
    forEach
} from 'jszip';

export default {

    data() {
        return {
            'correlacion': "",
            'capituloNota': "",
            'capituloNota22': "",
            'columnasCapituloNota': [],
            'datosCapituloNota': [],
            tigie2020: [],
            tigie2020Tablas: [],
            tigie2020Columnas: [],
            tigie2022: [],
            tigie2022Tablas: [],
            tigie2022Columnas: [],
            nueva_tabla: {
                'bFracciones': [],
                'bCuotas2': [],
                'bRegulacion': [],
                'bIEPS': [],
                'bProsec': [],
                'bTlc': [],
                'bAladi': [],
                'bTipat': [],
                'bHistoricoFracciones': [],
                'bPreciosEstimados': [],
                'bRcg2': [],
                'bReit': [],
                'bComercializadora': [],
                'bReglasOrigen': [],
                'bInformacionGeneral': [],
                'fracciones': []
            },
            nueva_tabla22: {
                'bFracciones': [],
                'bCuotas2': [],
                'bRegulacion': [],
                'bIEPS': [],
                'bProsec': [],
                'bTlc': [],
                'bAladi': [],
                'bTipat': [],
                'bHistoricoFracciones': [],
                'bPreciosEstimados': [],
                'bRcg2': [],
                'bReit': [],
                'bComercializadora': [],
                'bReglasOrigen': [],
                'bInformacionGeneral': [],
                'fracciones': []
            },
            ws_columnas_nueva_tabla: {
                'bFracciones': [],
                'bCuotas2': [],
                'bRegulacion': [],
                'bIEPS': [],
                'bProsec': [],
                'bTlc': [],
                'bAladi': [],
                'bTipat': [],
                'bHistoricoFracciones': [],
                'bPreciosEstimados': [],
                'bRcg2': [],
                'bReit': [],
                'bComercializadora': [],
                'bReglasdeOrigen': [],
                'bInformacionGeneral': [],
            },
            ws_columnas_nueva_tabla22: {
                'bFracciones': [],
                'bCuotas2': [],
                'bRegulacion': [],
                'bIEPS': [],
                'bProsec': [],
                'bTlc': [],
                'bAladi': [],
                'bTipat': [],
                'bHistoricoFracciones': [],
                'bPreciosEstimados': [],
                'bRcg2': [],
                'bReit': [],
                'bComercializadora': [],
                'bReglasdeOrigen': [],
                'bInformacionGeneral': [],
            },
            actualizaTabla: "tablaVS",
            search20: '',
            search22: '',
            active: [],
            filtrados: [],
            avatar: null,
            visible_download1: false,
            visible_download2: false,
            open: [],
            open_all: false,
            users: [],
            items: [],
            tigie: "",
            error: "",
            fracciones: [],
            ws_fracciones: [],
            ws_tablas: [],
            ws_columnas: [],
            mostrar_todas: false,
            menu3: false,
            menu4: false,
            URL: "",
            info_fraccion: "",
            nueva_tarifa: "",
            nueva_tarifa_reporte: "",
            lista_categorias: [],
            lista_fracciones_cliente: [],
            lista_fracciones_cliente_22: [],
            model: {
                rfc: "",
                fecha_de: "",
                fecha_a: "2020-12-27",
                lista: "",
                reporte_url: "/reportes_vucem/consultar_pedimentos/",
                nombre_reporte: "Pedimentos WS",
                tipo: "Pedimentos WS",
                tipo_reporte: "",
                capitulo: "01",
                opcion:"fracciones",
            },
            tipos: [

                {
                    "id": 4,
                    "text": "Código Estadistico por Capítulo 7ta Enmienda"
                },

                // , {
                //     "id": 3,
                //     "text": "Código Estadístico y NICO´s"
                // }
            ],
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "TIGIE",
                    disabled: true,
                    href: ""
                }
            ],
            fracciones_cliente: [],
            rules: {
                required: v => !!v || "Este campo es requerido",
                numeric: value => {
                    const pattern = /^[\d]*$/;
                    return pattern.test(value) || "Solo se permiten números";
                }
            },
            search: "",
            nombres_tablas: {
                'fraccion': 'Tarifa General',
                'tlcs': 'TLC',
                'tipat': 'TIPAT',
                'prosec': 'Prosec',
                'aladi2': 'ALADI',
                'regulaciones': 'Regulaciones',
                'cupo': 'Cupo',
                'preciosestimados2': 'Precios Estimados',
                'historicopreciosestimados': 'Historico de Precios Estimados',
                'anexo2vehiculos': 'Annexo 2 Vehiculos',
                'fraccionesanteriores': 'Fracciones Anteriores',
                'requisitoprevio': 'Requisito Previo',
                'rcg2': 'Anexos Reglas',
                'cuotas2': 'Cuotas Compensatorias',
                'reglasorigen': 'Reglas Origen',
                'comercializadora': 'Comercializadora',
                'reit': 'REIT',
                'ieps': 'IEPS',
                'iva': 'IVA',
                'infoimp': 'Info. Importación',
                'infoexp': 'Info. Exportación',
                'observaciones': 'Observaciones',
                'notas': 'Notas',
                'historicofracciones': 'Historico de Fracciones',
                'fracciones': 'Fracciones'
            },
            columns: ["fraccion"],
            options: {
                filterable: ["fraccion"],
                sortable: ["fraccion"],

                headings: {
                    fraccion: "Fraccion",
                }
            },
            columns_table_nueva: [
                "Fraccion",
                "Descripcion",
                "FraccionPunto",
                "NICO"
            ],
            table_nueva_options: {
                filterable: false,
                filterByColumn: false,
                headings: {
                    "Fraccion": "Fracción",
                    "Descripcion": "Descripción",
                    "FraccionPunto": "Fracción con Punto",
                    "NICO": "NICO"
                }
            },
            columns_capitulo: [
                "title",
                "value",
            ],
            capitulo_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                headings: {
                    "title": "",
                    "value": "",
                }
            },
            data_table_nueva_excel: {
                "FRACCIÓN ARANCELARIA TIGIE 2012": "fraccion",
                "FRACCIÓN CON PUNTO": "fraccion_punto",
                "DESCRIPCIÓN": "descripcion",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "fraccion_enmienda",
                "FRACCIÓN CON PUNTO 2020": "enmienda_punto",
                "NICO": "nico",
                "FRACCIÓN + QUINTO PAR": "concatenada",
                "ESTATUS": "estatus",
                "DESCRIPCIÓN 2020": "descripcion_enmienda",
            },
            data_table_nueva_excel_22: {
                "FRACCIÓN ARANCELARIA TIGIE 2020": "fraccion",
                "FRACCIÓN CON PUNTO": "fraccion_punto",
                "DESCRIPCIÓN": "descripcion",
                "FRACCIÓN ARANCELARIA TIGIE 2022": "fraccion_enmienda",
                "FRACCIÓN CON PUNTO 2022": "enmienda_punto",
                "NICO": "nico",
                "FRACCIÓN + QUINTO PAR": "concatenada",
                "ESTATUS": "estatus",
                "DESCRIPCIÓN 2022": "descripcion_enmienda",
            },

            data_table_impo: [],
            columns_table_impo: [
                "capitulo",
                "ws.fraccion",
                "actual.Descripcion",
                "actual.UMClave",
                "actual.UMAbreviacion",
                "actual.AdvImpoTxt",
                "nueva.Fraccion",
                "nueva.FraccionPunto",
                "nueva.NICO",
                "nueva.Descripcion",
                "nueva.UMClave",
                "nueva.UMAbreviacion",
                "nueva.AdvImpoTxt",
            ],
            table_impo_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'capitulo',
                    ascending: true
                },
                multiSorting: {
                    capitulo: [{
                            column: 'nueva.Fraccion',
                            matchDir: true
                        },
                        {
                            column: 'ws.fraccion',
                            matchDir: true
                        }
                    ]
                },
                headings: {
                    "capitulo": "CAPÍTULO",
                    "ws.fraccion": "FRACCIÓN ARANCELARIA TIGIE 2012",
                    "actual.Descripcion": "DESCRIPCIÓN",
                    "actual.UMClave": "UM CLAVE",
                    "actual.UMAbreviacion": "UM DESC.",
                    "actual.AdvImpoTxt": "ADV IMPO.",
                    "nueva.Fraccion": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "nueva.FraccionPunto": "FRACCION PUNTO",
                    "nueva.NICO": "NICO",
                    "nueva.Descripcion": "DESCRIPCIÓN 2020",
                    "nueva.UMClave": "UM CLAVE",
                    "nueva.UMAbreviacion": "UM DESC.",
                    "nueva.AdvImpoTxt": "ADV IMPO."
                }
            },
            table_impo_options_22: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'capitulo',
                    ascending: true
                },
                multiSorting: {
                    capitulo: [{
                            column: 'nueva.Fraccion',
                            matchDir: true
                        },
                        {
                            column: 'ws.fraccion',
                            matchDir: true
                        }
                    ]
                },
                headings: {
                    "capitulo": "CAPÍTULO",
                    "ws.fraccion": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "actual.Descripcion": "DESCRIPCIÓN",
                    "actual.UMClave": "UM CLAVE",
                    "actual.UMAbreviacion": "UM DESC.",
                    "actual.AdvImpoTxt": "ADV IMPO.",
                    "nueva.Fraccion": "FRACCIÓN ARANCELARIA TIGIE 2022",
                    "nueva.FraccionPunto": "FRACCION PUNTO",
                    "nueva.NICO": "NICO",
                    "nueva.Descripcion": "DESCRIPCIÓN 2022",
                    "nueva.UMClave": "UM CLAVE",
                    "nueva.UMAbreviacion": "UM DESC.",
                    "nueva.AdvImpoTxt": "ADV IMPO."
                }
            },
            columns_table_impo_todas: [
                "ws.fraccion",
                "actual2012.Descripcion",
                "actual2012.UMClave",
                "actual2012.UMAbreviacion",
                "actual2020.Fraccion",
                "actual2020.FraccionPunto",
                "actual2020.NICO",
                "actual2020.Descripcion",
                "actual2020.UMClave",
                "actual2020.UMAbreviacion",
                "nueva.Fraccion",
                "nueva.FraccionPunto",
                "nueva.NICO",
                "nueva.Descripcion",
                "nueva.UMClave",
                "nueva.UMAbreviacion",
            ],
            table_impo_options_22_todas: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'actual2012.Fraccion',
                    ascending: true
                },
                multiSorting: {
                    capitulo: [{
                            column: 'nueva.Fraccion',
                            matchDir: true
                        },
                        {
                            column: 'actual2020.Fraccion',
                            matchDir: true
                        },
                        {
                            column: 'ws.fraccion',
                            matchDir: true
                        }
                    ]
                },
                headings: {
                    "ws.fraccion": "FRACCIÓN ARANCELARIA TIGIE 2012",
                    "actual2012.Descripcion": "DESCRIPCIÓN",
                    "actual2012.UMClave": "UM CLAVE",
                    "actual2012.UMAbreviacion": "UM DESC.",
                    "actual2020.Fraccion": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "actual2020.FraccionPunto": "FRACCION PUNTO 2020",
                    "actual2020.NICO": "NICO 2020",
                    "actual2020.Descripcion": "DESCRIPCIÓN 2020",
                    "actual2020.UMClave": "UM CLAVE 2020",
                    "actual2020.UMAbreviacion": "UM DESC. 2020",
                    "nueva.Fraccion": "FRACCIÓN ARANCELARIA TIGIE 2022",
                    "nueva.FraccionPunto": "FRACCION PUNTO 2022",
                    "nueva.NICO": "NICO 2022",
                    "nueva.Descripcion": "DESCRIPCIÓN 2022",
                    "nueva.UMClave": "UM CLAVE 2022",
                    "nueva.UMAbreviacion": "UM DESC. 2022",
                }
            },
            data_table_impo_excel: {
                "CAPÍTULO": "capitulo",
                "FRACCIÓN ARANCELARIA TIGIE 2012": "ws.fraccion",
                "DESCRIPCIÓN": "actual.Descripcion",
                "UM CLAVE": "actual.UMClave",
                "UM DESC.": "actual.UMAbreviacion",
                "ADV IMPO.": "actual.AdvImpoTxt",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "nueva.Fraccion",
                "FRACCION PUNTO": "nueva.FraccionPunto",
                "NICO": "nueva.NICO",
                "DESCRIPCIÓN 2020": "nueva.Descripcion",
                "UM CLAVE 2020": "nueva.UMClave",
                "UM DESC. 2020": "nueva.UMAbreviacion",
                //   "ADV IMPO. 2020": "nueva.AdvImpoNum",
                "ADV IMPO. 2020": "nueva.AdvImpoTxt",
                //     "Tipo Tasa Adv Impo 2020": "nueva.TipoTasaAdvImpo",
                "Tasa IVA Franja": "nueva.TasaIVAFranja",
                "Tasa IVA Interior": "nueva.TasaIVAInterior",
                "Tasa ISAN": "nueva.TasaISAN",
                "Arancel Mixto": "nueva.ArancelMixto",
                "Tasa Mixta": "nueva.TasaMixta",
                "Arancel Especifico": "nueva.ArancelEspecifico",
                "Tipo Vehiculo": "nueva.TipoVehiculo",
                "Aplica ISAN": "nueva.AplicaISAN",
                "Aplica IEPS": "nueva.AplicaIEPS",
            },
            data_table_impo_excel_22: {
                "CAPÍTULO": "capitulo",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "ws.fraccion",
                "DESCRIPCIÓN": "actual.Descripcion",
                "UM CLAVE": "actual.UMClave",
                "UM DESC.": "actual.UMAbreviacion",
                "ADV IMPO.": "actual.AdvImpoTxt",
                "FRACCIÓN ARANCELARIA TIGIE 2022": "nueva.Fraccion",
                "FRACCION PUNTO": "nueva.FraccionPunto",
                "NICO": "nueva.NICO",
                "DESCRIPCIÓN 2022": "nueva.Descripcion",
                "UM CLAVE 2022": "nueva.UMClave",
                "UM DESC. 2022": "nueva.UMAbreviacion",
                //   "ADV IMPO. 2020": "nueva.AdvImpoNum",
                "ADV IMPO. 2022": "nueva.AdvImpoTxt",
                //     "Tipo Tasa Adv Impo 2020": "nueva.TipoTasaAdvImpo",
                "Tasa IVA Franja": "nueva.TasaIVAFranja",
                "Tasa IVA Interior": "nueva.TasaIVAInterior",
                "Tasa ISAN": "nueva.TasaISAN",
                "Arancel Mixto": "nueva.ArancelMixto",
                "Tasa Mixta": "nueva.TasaMixta",
                "Arancel Especifico": "nueva.ArancelEspecifico",
                "Tipo Vehiculo": "nueva.TipoVehiculo",
                "Aplica ISAN": "nueva.AplicaISAN",
                "Aplica IEPS": "nueva.AplicaIEPS",
            },
            data_table_impo_excel_todas: {
                "FRACCIÓN ARANCELARIA TIGIE 2012": "ws.fraccion",
                "DESCRIPCIÓN": "actual2012.Descripcion",
                "UM CLAVE": "actual2012.UMClave",
                "UM DESC.": "actual2012.UMAbreviacion",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "actual2020.Fraccion",
                "FRACCION PUNTO 2020": "actual2020.FraccionPunto",
                "NICO 2020": "actual2020.NICO",
                "DESCRIPCIÓN 2020": "actual2020.Descripcion",
                "UM CLAVE 2020": "actual2020.UMClave",
                "UM DESC. 2020": "actual2020.UMAbreviacion",
                "FRACCIÓN ARANCELARIA TIGIE 2022": "nueva.Fraccion",
                "FRACCION PUNTO 2022": "nueva.FraccionPunto",
                "NICO 2022": "nueva.NICO",
                "DESCRIPCIÓN 2022": "nueva.Descripcion",
                "UM CLAVE 2022": "nueva.UMClave",
                "UM DESC. 2022": "nueva.UMAbreviacion",
            },
            data_table_expo: [],
            columns_table_expo: [
                "capitulo",
                "ws.fraccion",
                "actual.Descripcion",
                "actual.UMClave",
                "actual.UMAbreviacion",
                "actual.AdvExpoTxt",
                "nueva.Fraccion",
                "nueva.FraccionPunto",
                "nueva.NICO",
                "nueva.Descripcion",
                "nueva.UMClave",
                "nueva.UMAbreviacion",
                "nueva.AdvExpoTxt",
            ],
            table_expo_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'capitulo',
                    ascending: true
                },
                multiSorting: {
                    capitulo: [{
                            column: 'nueva.Fraccion',
                            matchDir: true
                        },
                        {
                            column: 'ws.fraccion',
                            matchDir: true
                        }
                    ]
                },
                headings: {
                    "capitulo": "CAPÍTULO",
                    "ws.fraccion": "FRACCIÓN ARANCELARIA TIGIE 2012",
                    "actual.Descripcion": "DESCRIPCIÓN",
                    "actual.UMClave": "UM CLAVE",
                    "actual.UMAbreviacion": "UM DESC.",
                    "actual.AdvExpoTxt": "ADV EXPO",
                    "nueva.Fraccion": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "nueva.FraccionPunto": "FRACCION PUNTO",
                    "nueva.NICO": "NICO",
                    "nueva.Descripcion": "DESCRIPCIÓN 2020",
                    "nueva.UMClave": "UM CLAVE",
                    "nueva.UMAbreviacion": "UMA DESC.",
                    "nueva.AdvExpoTxt": "ADV EXPO.",
                }
            },
            table_expo_options_22: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'capitulo',
                    ascending: true
                },
                multiSorting: {
                    capitulo: [{
                            column: 'nueva.Fraccion',
                            matchDir: true
                        },
                        {
                            column: 'ws.fraccion',
                            matchDir: true
                        }
                    ]
                },
                headings: {
                    "capitulo": "CAPÍTULO",
                    "ws.fraccion": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "actual.Descripcion": "DESCRIPCIÓN",
                    "actual.UMClave": "UM CLAVE",
                    "actual.UMAbreviacion": "UM DESC.",
                    "actual.AdvExpoTxt": "ADV EXPO",
                    "nueva.Fraccion": "FRACCIÓN ARANCELARIA TIGIE 2022",
                    "nueva.FraccionPunto": "FRACCION PUNTO",
                    "nueva.NICO": "NICO",
                    "nueva.Descripcion": "DESCRIPCIÓN 2022",
                    "nueva.UMClave": "UM CLAVE",
                    "nueva.UMAbreviacion": "UMA DESC.",
                    "nueva.AdvExpoTxt": "ADV EXPO.",
                }
            },
            data_table_expo_excel: {
                "CAPÍTULO": "capitulo",
                "FRACCIÓN ARANCELARIA TIGIE 2012": "ws.fraccion",
                "DESCRIPCIÓN": "actual.Descripcion",
                "UM CLAVE": "actual.UMClave",
                "UM DESC.": "actual.UMAbreviacion",
                "ADV EXPO.": "actual.AdvExpoTxt",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "nueva.Fraccion",
                "FRACCION PUNTO": "nueva.FraccionPunto",
                "NICO": "nueva.NICO",
                "DESCRIPCIÓN 2020": "nueva.Descripcion",
                "UM Clave 2020": "nueva.UMClave",
                "UM DESC. 2020": "nueva.UMAbreviacion",
                "ADV EXPO. 2020": "nueva.AdvExpoTxt",
                //  "ADV EXPO. 2020 ": "nueva.AdvExpoNum",
                //  "Tipo Tasa Adv Expo": "nueva.TipoTasaAdvExpo",
                "Tasa IVA Franja": "nueva.TasaIVAFranja",
                "Tasa IVA Interior": "nueva.TasaIVAInterior",
                "Tasa ISAN": "nueva.TasaISAN",
                "Arancel Mixto": "nueva.ArancelMixto",
                "Tasa Mixta": "nueva.TasaMixta",
                "Arancel Especifico": "nueva.ArancelEspecifico",
                "Tipo Vehiculo": "nueva.TipoVehiculo",
                "Aplica ISAN": "nueva.AplicaISAN",
                "Aplica IEPS": "nueva.AplicaIEPS",
            },
            data_table_expo_excel_22: {
                "CAPÍTULO": "capitulo",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "ws.fraccion",
                "DESCRIPCIÓN": "actual.Descripcion",
                "UM CLAVE": "actual.UMClave",
                "UM DESC.": "actual.UMAbreviacion",
                "ADV EXPO.": "actual.AdvExpoTxt",
                "FRACCIÓN ARANCELARIA TIGIE 2022": "nueva.Fraccion",
                "FRACCION PUNTO": "nueva.FraccionPunto",
                "NICO": "nueva.NICO",
                "DESCRIPCIÓN 2022": "nueva.Descripcion",
                "UM Clave 2022": "nueva.UMClave",
                "UM DESC. 2022": "nueva.UMAbreviacion",
                "ADV EXPO. 2022": "nueva.AdvExpoTxt",
                //  "ADV EXPO. 2020 ": "nueva.AdvExpoNum",
                //  "Tipo Tasa Adv Expo": "nueva.TipoTasaAdvExpo",
                "Tasa IVA Franja": "nueva.TasaIVAFranja",
                "Tasa IVA Interior": "nueva.TasaIVAInterior",
                "Tasa ISAN": "nueva.TasaISAN",
                "Arancel Mixto": "nueva.ArancelMixto",
                "Tasa Mixta": "nueva.TasaMixta",
                "Arancel Especifico": "nueva.ArancelEspecifico",
                "Tipo Vehiculo": "nueva.TipoVehiculo",
                "Aplica ISAN": "nueva.AplicaISAN",
                "Aplica IEPS": "nueva.AplicaIEPS",
            },
            data_table_m_impo: [],
            columns_table_m_impo: [
                "fraccion",
                "descripcion_partida",
                "descripcion",
                "capitulo",
                "fraccion_enmienda",
                "nico",
                "concatenada",
                "estatus",
                "descripcion_enmienda",
                "nueva.UMClave",
                "nueva.UMAbreviacion",
                "nueva.AdvImpoTxt",
                "nueva.AdvExpoTxt",
                /* "nueva.TipoTasaAdvImpo",
                "nueva.AdvExpoTxt",
                "nueva.AdvExpoNum",
                "nueva.TipoTasaAdvExpo",
                "nueva.TasaIVAFranja",
                "nueva.TasaIVAInterior",
                "nueva.TasaISAN",
                "nueva.ArancelMixto",
                "nueva.TasaMixta",
                "nueva.ArancelEspecifico",
                "nueva.TipoVehiculo",
                "nueva.AplicaISAN",
                "nueva.AplicaIEPS" */
            ],
            table_m_impo_options: {
                filterable: true,
                sortable: [],
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'fraccion_enmienda',
                    ascending: true
                },
                multiSorting: {
                    fraccion_enmienda: [{
                        column: 'nico',
                        matchDir: true
                    }]
                },
                headings: {

                    "fraccion": "FRACCIÓN ARANCELARIA TIGIE 2012",
                    "fraccion_enmienda": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "nico": "NICO",
                    "capitulo": "CAPÍTULO",
                    "concatenada": "FRACCIÓN + QUINTO PAR",
                    "estatus": "ESTATUS",
                    "descripcion_partida": "DESCRIPCIÓN DE PARTIDA",
                    "descripcion": "DESCRIPCIÓN",
                    "descripcion_enmienda": "DESCRIPCIÓN 2020",
                    "nueva.UMClave": "UM CLAVE",
                    "nueva.UMAbreviacion": "UM DESC.",
                    "nueva.AdvImpoTxt": "ADV IMPO.",
                    "nueva.TipoTasaAdvImpo": "Tipo Tasa Adv Impo",
                    "nueva.AdvExpoTxt": "ADV EXPO.",
                    "nueva.AdvExpoNum": "ADV EXPO",
                    "nueva.TipoTasaAdvExpo": "TipoTasaAdvExpo",
                    "nueva.TasaIVAFranja": "TasaIVAFranja",
                    "nueva.TasaIVAInterior": "TasaIVAInterior",
                    "nueva.TasaISAN": "TasaISAN",
                    "nueva.ArancelMixto": "ArancelMixto",
                    "nueva.TasaMixta": "TasaMixta",
                    "nueva.ArancelEspecifico": "ArancelEspecifico",
                    "nueva.TipoVehiculo": "TipoVehiculo",
                    "nueva.AplicaISAN": "AplicaISAN",
                    "nueva.AplicaIEPS": "AplicaIEPS",
                }
            },
            table_m_impo_options_22: {
                filterable: true,
                sortable: [],
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'fraccion_enmienda',
                    ascending: true
                },
                multiSorting: {
                    fraccion_enmienda: [{
                        column: 'nico',
                        matchDir: true
                    }]
                },
                headings: {

                    "fraccion": "FRACCIÓN ARANCELARIA TIGIE 2020",
                    "fraccion_enmienda": "FRACCIÓN ARANCELARIA TIGIE 2022",
                    "nico": "NICO",
                    "capitulo": "CAPÍTULO",
                    "concatenada": "FRACCIÓN + QUINTO PAR",
                    "estatus": "ESTATUS",
                    "descripcion_partida":"DESCRIPCIÓN DE PARTIDA",
                    "descripcion": "DESCRIPCIÓN",
                    "descripcion_enmienda": "DESCRIPCIÓN 2022",
                    "nueva.UMClave": "UM CLAVE",
                    "nueva.UMAbreviacion": "UM DESC.",
                    "nueva.AdvImpoTxt": "ADV IMPO.",
                    "nueva.TipoTasaAdvImpo": "Tipo Tasa Adv Impo",
                    "nueva.AdvExpoTxt": "ADV EXPO.",
                    "nueva.AdvExpoNum": "ADV EXPO",
                    "nueva.TipoTasaAdvExpo": "TipoTasaAdvExpo",
                    "nueva.TasaIVAFranja": "TasaIVAFranja",
                    "nueva.TasaIVAInterior": "TasaIVAInterior",
                    "nueva.TasaISAN": "TasaISAN",
                    "nueva.ArancelMixto": "ArancelMixto",
                    "nueva.TasaMixta": "TasaMixta",
                    "nueva.ArancelEspecifico": "ArancelEspecifico",
                    "nueva.TipoVehiculo": "TipoVehiculo",
                    "nueva.AplicaISAN": "AplicaISAN",
                    "nueva.AplicaIEPS": "AplicaIEPS",
                }
            },
            data_table_m_impo_excel: {
                "FRACCIÓN ARANCELARIA TIGIE 2012": "fraccion",
                "FRACCIÓN CON PUNTO": "fraccion_punto",
                "DESCRIPCIÓN DE PARTIDA": "descripcion_partida",
                "DESCRIPCIÓN": "descripcion",
                "CAPÍTULO": "capitulo2",
                "FRACCIÓN ARANCELARIA TIGIE 2020": "fraccion_enmienda2",
                "FRACCIÓN CON PUNTO 2020": "enmienda_punto",
                "NICO": "nico",
                "FRACCIÓN + QUINTO PAR": "concatenada",
                "ESTATUS": "estatus",
                "DESCRIPCIÓN 2020": "descripcion_enmienda",
                "UMClave": "nueva.UMClave",
                "UMAbreviacion": "nueva.UMAbreviacion",
                "AdvImpo": "nueva.AdvImpoTxt",
                //     "TipoTasaAdvImpo": "nueva.TipoTasaAdvImpo",
                "AdvExpo": "nueva.AdvExpoTxt",
                //    "AdvExpoNum": "nueva.AdvExpoNum",
                //   "TipoTasaAdvExpo": "nueva.TipoTasaAdvExpo",
                "TasaIVAFranja": "nueva.TasaIVAFranja",
                "TasaIVAInterior": "nueva.TasaIVAInterior",
                "TasaISAN": "nueva.TasaISAN",
                "ArancelMixto": "nueva.ArancelMixto",
                "TasaMixta": "nueva.TasaMixta",
                "ArancelEspecifico": "nueva.ArancelEspecifico",
                "TipoVehiculo": "nueva.TipoVehiculo",
                "AplicaISAN": "nueva.AplicaISAN",
                "AplicaIEPS": "nueva.AplicaIEPS",
            },
            data_table_m_impo_excel_22: {

                "FRACCIÓN ARANCELARIA TIGIE 2020": "fraccion",
                "FRACCIÓN CON PUNTO": "fraccion_punto",
                "DESCRIPCIÓN DE PARTIDA": "descripcion_partida",
                "DESCRIPCIÓN": "descripcion",
                "CAPÍTULO": "capitulo2",
                "FRACCIÓN ARANCELARIA TIGIE 2022": "fraccion_enmienda2",
                "FRACCIÓN CON PUNTO 2022": "enmienda_punto",
                "NICO": "nico",
                "FRACCIÓN + QUINTO PAR": "concatenada",
                "ESTATUS": "estatus",
                "DESCRIPCIÓN 2022": "descripcion_enmienda",
                "UMClave": "nueva.UMClave",
                "UMAbreviacion": "nueva.UMAbreviacion",
                "AdvImpo": "nueva.AdvImpoTxt",
                //     "TipoTasaAdvImpo": "nueva.TipoTasaAdvImpo",
                "AdvExpo": "nueva.AdvExpoTxt",
                //    "AdvExpoNum": "nueva.AdvExpoNum",
                //   "TipoTasaAdvExpo": "nueva.TipoTasaAdvExpo",
                "TasaIVAFranja": "nueva.TasaIVAFranja",
                "TasaIVAInterior": "nueva.TasaIVAInterior",
                "TasaISAN": "nueva.TasaISAN",
                "ArancelMixto": "nueva.ArancelMixto",
                "TasaMixta": "nueva.TasaMixta",
                "ArancelEspecifico": "nueva.ArancelEspecifico",
                "TipoVehiculo": "nueva.TipoVehiculo",
                "AplicaISAN": "nueva.AplicaISAN",
                "AplicaIEPS": "nueva.AplicaIEPS",
                },
            data_tarifa_actual: [],
            data_nueva_tarifa: []

        };
    },

    created: function () {
        this.URL = this.$hostname;
        this.cargar_categorias();
        this.get_fracciones_cliente();
        this.get_fracciones_cliente_22();
        this.getTigies();

    },
    mounted: function () {
        this.lista_categorias = this.lista_categorias.sort(function (a, b) {
            return a.id > b.id ? 1 : -1;
        });
    },
    computed: {
        keytabla() {
            return this.actualizaTabla;
        },

    },

    methods: {
        cambiafechas(){
            if(this.model.tipo_reporte == 1){
                this.model.fecha_a = "2020-12-27";
                this.model.fecha_de = "";
            }
            if(this.model.tipo_reporte == 3){
                this.model.fecha_de = "2020-12-27";
                this.model.fecha_a = "";
            }
            if(this.model.tipo_reporte == 5){
                //this.model.fecha_de = "2015-01-01";
                //this.model.fecha_a = "2023-04-30";
                this.model.fecha_de = "";
                this.model.fecha_a = "";
            }
        },
        eliminarDuplicados: function(arreglo) {
            var jsonobj = JSON.parse(JSON.stringify(arreglo));
            var objetosUnicos = {};
            var resultados = [];

            jsonobj.forEach(function(item) {
                var objeto = {"actual2012":item.actual2012, "actual2020":item.actual2020, "nueva":item.nueva};
                /*if(objeto.ws2!="" && objeto.ws2.nico){
                    delete objeto.ws2.nico;
                } else if(objeto.ws3!="" && objeto.ws3.nico){
                    delete objeto.ws3.nico;
                }*/

                var cadenaObjeto = JSON.stringify(objeto);
                if (!objetosUnicos[cadenaObjeto]) {
                objetosUnicos[cadenaObjeto] = true;
                resultados.push(item);
                }
            });

            return resultados;
        },
        genera_reporte() {

            this.data_table_impo = [];
            this.data_table_m_impo = [];
            this.data_table_expo = [];
            this.data_table_m_expo = [];
            if (this.model.tipo_reporte == 1) {
                this.visible_download1 = false;
                this.consulta_relacionadas();
            }
            if (this.model.tipo_reporte == 3) {
                this.visible_download1 = false;
                this.consulta_relacionadas_22();
            }
            if (this.model.tipo_reporte == 5) { //Saca fracciones con su relacion de 2012, 2020, 2022
                this.visible_download1 = false;
                this.consulta_relacionadas_todas();
            }

            if (this.model.tipo_reporte == 2) {
                this.visible_download2 = false;
                this.consulta_nicos();
            }
            if (this.model.tipo_reporte == 4) {
                this.visible_download2 = false;
                this.consulta_nicos_2022();
            }


        },
        validaFecha: function (fecha) {
            if (fecha != 'udefined' && fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != 'undefined' && this.model.fecha_a != 'undefined' && this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        validaDias: function () {
            if (this.model.fecha_de != 'undefined' && this.model.fecha_a != 'undefined' && this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 31)
                    return "Periodo máximo de consulta 31 dias. Favor de verificar."
            }
            return true;
        },
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        async cargar_categorias() {
            let self = this;
            for (var i = 0; i < 23; i++) {
                await axios.post(self.$hostname + "catalogos/fracciones/get_childrens/", {
                    "id": i,
                    "tipo": "seccion"
                }).then(r => {
                    self.lista_categorias = self.lista_categorias.concat(r.data);
                    self.lista_categorias = self.lista_categorias.sort(function (a, b) {
                        return a.id > b.id ? 1 : -1;
                    });
                });
            }

        },
        async buscar_correlacion_2022() {
            let self = this;

            await axios.post(self.$hostname + "vucem/list_correlacion/", {
                "tigie2020": this.search20,
            }).then(r => {
                self.correlacion = r.data;

                if (self.correlacion.length > 0) {
                    //console.log(self.correlacion[0]);
                    this.search22 = self.correlacion[0]['tigie2022'];
                    self.buscar22();
                }

            });

        },
        buscar_old: function (texto) {

            let datos = {
                clave: texto
            }
            this.info_fraccion = "";
            axios.post(this.$hostname + "catalogos/fracciones/get_fraccion/", datos)
                .then(response => {
                    this.info_fraccion = response.data.fracciones[0];

                })
                .catch(error => {

                }).then(() => {});

        },
        arreglaMes(mes) {
            let r = "";
            r = mes.replace('Jan', 'Ene');
            r = r.replace('Apr', 'Abr');
            r = r.replace('Aug', 'Ago');
            r = r.replace('Dec', 'Dic');

            return r;
        },
        async buscar() {
            this.search = this.search.replace(/\./g, '');
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            //     this.obtenerNuevaTabla('bFracciones', this.search);

            let datos = {
                cmd: 'fracciondetails',
                u: 'lourdes.aguilar@econnect.mx',
                p: '12345678',
                f: '01012101',
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            }

            if (!this.$refs.form.validate()) {
                this.$root.$dialogLoader.hide();
            } else {
                let selft = this;
                selft.ws_fracciones = [];
                selft.ws_columnas = [];
                selft.nueva_tarifa = [];
                selft.error = "La Fracción no fue localizada";
                //  await this.buscar_old(this.search);

                await fetch('https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fracciondetails&u=lourdes.aguilar@econnect.mx&p=12345678&f=' + this.search.substring(0, 8))
                    .then(response => response.text())
                    .then(data => {

                        var parser = new DOMParser();
                        var xmlDoc = parser.parseFromString(data, "text/xml");
                        let x = xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue;

                        var obj = JSON.parse(x);
                        //console.log(obj);
                        this.ws_fracciones = obj;
                        this.ws_tablas = Object.keys(obj);
                        this.ws_tablas.forEach(function (i) {

                            if (selft.ws_fracciones[i].length > 0) {
                                selft.ws_columnas[i] = Object.keys(selft.ws_fracciones[i][0]);
                            }

                        });

                        this.$root.$dialogLoader.hide();
                    }).catch(function (error) {
                        this.$root.$dialogLoader.hide();
                        this.error = "No se obtuvo respuesta";
                    });
                let datos = {
                    fraccion: this.search
                }

                //   https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fraccioncorrelacion&u=lourdes.aguilar@econnect.mx&p=12345678&f=01041099
                await fetch('https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fraccioncorrelacion&u=lourdes.aguilar@econnect.mx&p=12345678&f=' + this.search.substring(0, 8))
                    .then(response => response.text())
                    .then(data => {

                        var parser = new DOMParser();
                        var xmlDoc = parser.parseFromString(data, "text/xml");
                        let x = xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue;

                        var obj = JSON.parse(x);
                        //console.log(obj);
                        selft.nueva_tarifa = obj;

                    }).catch(function (error) {});
                /* axios.post(this.$hostname + "reportes/fracciones_tigie/", datos)
                    .then(response => {
                        selft.nueva_tarifa = response.data;

                    })
                    .catch(error => {

                    }).then(() => {}); */
            }
        },
        async buscar20() {
            let self = this;
            this.capituloNota = "";
            this.nueva_tabla = {
                'bFracciones': [],
                'bCuotas2': [],
                'bRegulacion': [],
                'bIEPS': [],
                'bProsec': [],
                'bTlc': [],
                'bAladi': [],
                'bTipat': [],
                'bHistoricoFracciones': [],
                'bPreciosEstimados': [],
                'bRcg2': [],
                'bReit': [],
                'bComercializadora': [],
                'bReglasOrigen': [],
                'bInformacionGeneral': [],
            };

            this.search20 = this.search20.replace(/\./g, '');
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            if (!this.$refs.form2.validate()) {
                this.$root.$dialogLoader.hide();
            } else {

                /*        await this.obtenerNuevaTabla('bFracciones', this.search20);
                       await this.obtenerNuevaTablaNICO('bRegulacion', this.search20);
                       await this.obtenerNuevaTablaNICO('bIEPS', this.search20);
                       await this.obtenerNuevaTablaNICO('bProsec', this.search20);
                       await this.obtenerNuevaTablaNICO('bTlc', this.search20);
                       await this.obtenerNuevaTablaNICO('bAladi', this.search20);
                       await this.obtenerNuevaTablaNICO('bTipat', this.search20);
                       await this.obtenerNuevaTabla('bHistoricoFracciones', this.search20);
                       await this.obtenerNuevaTablaNICO('bPreciosEstimados', this.search20);
                       await this.obtenerNuevaTablaNICO('bRcg2', this.search20);
                       await this.obtenerNuevaTablaNICO('bReit', this.search20);
                       await this.obtenerNuevaTablaNICO('bReglasOrigen', this.search20);
                       await this.obtenerNuevaTablaNICO('bInformacionGeneral', this.search20); */

                let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion=" + self.search20 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";

                fetch(url)
                    .then(response => response.json())
                    .then(function (data) {
                        self.nueva_tabla = data;
                        if (data.length > 0)
                            self.nueva_tabla = data[0];

                        self.tigie2020Tablas = Object.keys(self.nueva_tabla);
                        self.tigie2020Tablas.forEach(function (i) {

                            if (self.nueva_tabla[i].length > 0) {
                                self.ws_columnas_nueva_tabla[i] = Object.keys(self.nueva_tabla[i][0]);

                            }

                        });
                        self.buscar_correlacion_2022();
                        //  self.nueva_tabla["bPreciosEstimados"]=[];
                        //    self.obtenerNuevaTablaNICO('bPreciosEstimados', self.search20);

                    })
                    .catch(err => {
                        console.log(err);
                    });
                this.$root.$dialogLoader.hide();
            }

        },
        async buscar22() {
            let self = this;
            this.capituloNota22 = "";
            this.nueva_tabla22 = {
                'bFracciones': [],
                'bCuotas2': [],
                'bRegulacion': [],
                'bIEPS': [],
                'bProsec': [],
                'bTlc': [],
                'bAladi': [],
                'bTipat': [],
                'bHistoricoFracciones': [],
                'bPreciosEstimados': [],
                'bRcg2': [],
                'bReit': [],
                'bComercializadora': [],
                'bReglasOrigen': [],
                'bInformacionGeneral': [],
            };

            this.search22 = this.search22.replace(/\./g, '');
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            /*        await this.obtenerNuevaTabla('bFracciones', this.search20);
                   await this.obtenerNuevaTablaNICO('bRegulacion', this.search20);
                   await this.obtenerNuevaTablaNICO('bIEPS', this.search20);
                   await this.obtenerNuevaTablaNICO('bProsec', this.search20);
                   await this.obtenerNuevaTablaNICO('bTlc', this.search20);
                   await this.obtenerNuevaTablaNICO('bAladi', this.search20);
                   await this.obtenerNuevaTablaNICO('bTipat', this.search20);
                   await this.obtenerNuevaTabla('bHistoricoFracciones', this.search20);
                   await this.obtenerNuevaTablaNICO('bPreciosEstimados', this.search20);
                   await this.obtenerNuevaTablaNICO('bRcg2', this.search20);
                   await this.obtenerNuevaTablaNICO('bReit', this.search20);
                   await this.obtenerNuevaTablaNICO('bReglasOrigen', this.search20);
                   await this.obtenerNuevaTablaNICO('bInformacionGeneral', this.search20); */

            let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion=" + self.search22 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";

            fetch(url)
                .then(response => response.json())
                .then(function (data) {
                    self.nueva_tabla22 = data;
                    if (data.length > 0)
                        self.nueva_tabla22 = data[0];

                    self.tigie2022Tablas = Object.keys(self.nueva_tabla22);
                    self.tigie2022Tablas.forEach(function (i) {

                        if (self.nueva_tabla22[i].length > 0) {
                            self.ws_columnas_nueva_tabla22[i] = Object.keys(self.nueva_tabla22[i][0]);

                        }

                    });
                    //  self.nueva_tabla["bPreciosEstimados"]=[];
                    //    self.obtenerNuevaTablaNICO('bPreciosEstimados', self.search20);

                })
                .catch(err => {
                    console.log(err);
                });
            this.$root.$dialogLoader.hide();

        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },

        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        downloadURL: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        obtener_datos_gs_smart: async function (url) {
            return new Promise(function (resolve, reject) {
                fetch(url)
                    .then(response => response.text())
                    .then(data => {
                        var parser = new DOMParser();
                        var xmlDoc = parser.parseFromString(data, "text/xml");
                        let x = xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue;
                        var obj = JSON.parse(x);

                        resolve(obj);
                    }).catch(err => {
                        console.log("error en obtener_datos_gs_smart: ", err);
                        reject(0);
                    });
            })
        },
        llenar_tarifa_actual: function (records, tipo) {
            let self = this;
            return new Promise(function (resolve, reject) {
                let contador1 = 0;
                let cadena = "";
                let arr_cadena = [];
                records.forEach(async function (f) {

                    if (f.fraccion != "")
                        cadena += "%27" + f.fraccion + "%27,";

                    contador1 += 1;

                    if ((contador1 % 100 == 0) || records.length == contador1) {
                        cadena = cadena.slice(0, -1);
                        arr_cadena.push(cadena);
                        cadena = "";

                    }
                });

                arr_cadena.forEach(async function (item) {
                    //SE OBTIENE TARIFA ACTUAL
                    let _url = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=sFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';

                    let data = await self.obtener_datos_gs_smart(_url);
                    data.forEach(function (f) {
                        let encontrado = 'undefined';
                        if (tipo == "I")
                            encontrado = self.data_table_impo.find(actual => actual.ws.fraccion == f.Fraccion);
                        else
                            encontrado = self.data_table_expo.find(actual => actual.ws.fraccion == f.Fraccion);

                        if (encontrado != 'undefined')
                            encontrado.actual = f;
                    });
                });
                resolve(1);
            })

        },
        llenar_tarifa_actual_2012:async function (records, tipo) {
            let self = this;
            return new Promise(async function (resolve, reject) {
                try {
                    console.log("Iniciando 2012");
                    let contador1 = 0;
                    let cadena = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (f.fraccion != "")
                            cadena += "%27" + f.fraccion + "%27,";

                        contador1 += 1;

                        if ((contador1 % 100 == 0) || records.length == contador1) {
                            cadena = cadena.slice(0, -1);
                            arr_cadena.push(cadena);
                            cadena = "";

                        }
                    });

                    await Promise.all(arr_cadena.map(async (item) => {

                        //SE OBTIENE TARIFA ACTUAL
                        let _url = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=sFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';

                        let data = await self.obtener_datos_gs_smart(_url);
                        data.forEach(function (f) {
                            let encontrado = undefined;
                            if (tipo == "I")
                                encontrado = self.data_table_impo.find(actual => actual.ws.fraccion == f.Fraccion);
                            else
                                encontrado = self.data_table_expo.find(actual => actual.ws.fraccion == f.Fraccion);

                            if (encontrado)
                                encontrado.actual2012 = f;
                        });
                    }));
                    console.log("Terminando 2012");
                    return resolve(1);
                } catch (error) {
                    console.log("Error en llenar_tarifa_actual_2012: ", error);
                    this.$root.$dialogLoader.hide();
                    return reject(0);
                }

            });

        },
        llenar_nueva_tarifa_20: function (records, tipo) {
            let self = this;
            return new Promise(function (resolve, reject) {
                let contador1 = 0;
                let cadena_nueva = "";
                let arr_cadena = [];
                records.forEach(async function (f) {

                    if (tipo == "I" || tipo == "E") {
                        if (f.equivalencia.length > 0 && f.equivalencia[0] != undefined)
                            if (f.equivalencia[0].fraccion_enmienda != "" && f.equivalencia[0].nico != null)
                                cadena_nueva += "%27" + f.equivalencia[0].fraccion_enmienda + f.equivalencia[0].nico + "%27,";

                        contador1 += 1;

                        if ((contador1 % 50 == 0) || records.length == contador1) {
                            cadena_nueva = cadena_nueva.slice(0, -1);
                            arr_cadena.push(cadena_nueva);
                            cadena_nueva = "";

                        }
                    }
                    if (tipo == "ceI" || tipo == "ceE") {
                        if (f.fraccion_enmienda.length > 0) {

                            if (f.fraccion_enmienda != "" && f.nico != null)
                                cadena_nueva += "%27" + f.fraccion_enmienda + f.nico + "%27,";

                        }

                        contador1 += 1;

                        if ((contador1 % 50 == 0) || records.length == contador1) {
                            cadena_nueva = cadena_nueva.slice(0, -1);
                            arr_cadena.push(cadena_nueva);
                            cadena_nueva = "";

                        }
                    }

                });
                let cuenta = 0;
                arr_cadena.forEach(async function (item) {

                    //SE OBTIENE NUEVA TARIFA
                    let _url2 = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';
                    let data = await self.obtener_datos_gs_smart(_url2);

                    data.forEach(function (f) {
                        let encontrado = 'undefined';
                        if (tipo == "I") {

                            encontrado = self.data_table_impo.filter(actual => actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO);
                            encontrado.forEach(function (R) {
                                R.actual = f;
                            });
                        }

                        if (tipo == "E") {
                            encontrado = self.data_table_expo.filter(actual => actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO);
                            encontrado.forEach(function (R) {
                                R.actual = f;
                            });
                        }

                        if (tipo == "ceI") {
                            encontrado = self.data_table_m_impo.filter(actual => actual.fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.nico == f.NICO);
                            encontrado.forEach(function (R) {
                                R.actual = f;
                            });
                        }

                    });

                    cadena_nueva = "";
                    cuenta += 1;
                    self.actualizaTabla = "tablaVS-" + cuenta;
                });
                if (cuenta = arr_cadena.length) {
                    self.visible_download2 = true;
                    self.visible_download1 = true;

                    if (tipo == "I") {

                        self.data_table_impo = self.data_table_impo.sort(function (a, b) {
                            return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                        });
                    }
                    if (tipo == "E") {
                        self.data_table_expo = self.data_table_expo.sort(function (a, b) {
                            return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                        });
                    }
                    self.$root.$dialogLoader.hide();
                }
                resolve(1);
            })

        },
        llenar_nueva_tarifa: function (records, tipo) {
            let self = this;
            return new Promise(function (resolve, reject) {
                let contador1 = 0;
                let cadena_nueva = "";
                let arr_cadena = [];
                records.forEach(async function (f) {

                    if (tipo == "I" || tipo == "E") {
                        if (f.equivalencia.length > 0 && f.equivalencia[0] != undefined)
                            if (f.equivalencia[0].fraccion_enmienda != "" && f.equivalencia[0].nico != null)
                                cadena_nueva += "%27" + f.equivalencia[0].fraccion_enmienda + f.equivalencia[0].nico + "%27,";

                        contador1 += 1;

                        if ((contador1 % 50 == 0) || records.length == contador1) {
                            cadena_nueva = cadena_nueva.slice(0, -1);
                            arr_cadena.push(cadena_nueva);
                            cadena_nueva = "";

                        }
                    }
                    if (tipo == "ceI" || tipo == "ceE") {
                        if (f.fraccion_enmienda.length > 0) {

                            if (f.fraccion_enmienda != "" && f.nico != null)
                                cadena_nueva += "%27" + f.fraccion_enmienda + f.nico + "%27,";

                        }

                        contador1 += 1;

                        if ((contador1 % 50 == 0) || records.length == contador1) {
                            cadena_nueva = cadena_nueva.slice(0, -1);
                            arr_cadena.push(cadena_nueva);
                            cadena_nueva = "";

                        }
                    }

                });
                let cuenta = 0;
                arr_cadena.forEach(async function (item) {

                    //SE NUEVA TARIFA
                    let _url2 = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';
                    let data = await self.obtener_datos_gs_smart(_url2);

                    data.forEach(function (f) {
                        let encontrado = 'undefined';
                        if (tipo == "I") {

                            encontrado = self.data_table_impo.filter(actual => actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO);
                            encontrado.forEach(function (R) {
                                R.nueva = f;
                            });
                        }

                        if (tipo == "E") {
                            encontrado = self.data_table_expo.filter(actual => actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO);
                            encontrado.forEach(function (R) {
                                R.nueva = f;
                            });
                        }

                        if (tipo == "ceI") {
                            encontrado = self.data_table_m_impo.filter(actual => actual.fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.nico == f.NICO);
                            encontrado.forEach(function (R) {
                                R.nueva = f;
                            });
                        }

                    });

                    cadena_nueva = "";
                    cuenta += 1;
                    self.actualizaTabla = "tablaVS-" + cuenta;
                });
                if (cuenta = arr_cadena.length) {
                    self.visible_download2 = true;
                    self.visible_download1 = true;

                    if (tipo == "I") {

                        self.data_table_impo = self.data_table_impo.sort(function (a, b) {
                            return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                        });
                    }
                    if (tipo == "E") {
                        self.data_table_expo = self.data_table_expo.sort(function (a, b) {
                            return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                        });
                    }
                    self.$root.$dialogLoader.hide();
                }
                resolve(1);
            })

        },
        llenar_nueva_tarifa_2020:async function (records, tipo) {
            let self = this;
            return new Promise(async function (resolve, reject) {
                try {
                    let contador1 = 0;
                    let cadena_nueva = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (tipo == "I" || tipo == "E") {
                            if (f.equivalencia && f.equivalencia.length > 0 && f.equivalencia[0] != undefined)
                                if (f.equivalencia[0].fraccion_enmienda != "" && f.equivalencia[0].nico != null)
                                    cadena_nueva += "%27" + f.equivalencia[0].fraccion_enmienda + f.equivalencia[0].nico + "%27,";

                            contador1 += 1;

                            if ((contador1 % 50 == 0) || records.length == contador1) {
                                cadena_nueva = cadena_nueva.slice(0, -1);
                                arr_cadena.push(cadena_nueva);
                                cadena_nueva = "";

                            }
                        }
                        if (tipo == "ceI" || tipo == "ceE") {
                            if (f.fraccion_enmienda.length > 0) {

                                if (f.fraccion_enmienda != "" && f.nico != null)
                                    cadena_nueva += "%27" + f.fraccion_enmienda + f.nico + "%27,";

                            }

                            contador1 += 1;

                            if ((contador1 % 50 == 0) || records.length == contador1) {
                                cadena_nueva = cadena_nueva.slice(0, -1);
                                arr_cadena.push(cadena_nueva);
                                cadena_nueva = "";

                            }
                        }

                    });
                    let cuenta = 0;

                    await Promise.all(arr_cadena.map(async (item) => {

                        //SE NUEVA TARIFA
                        let _url2 = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';
                        let data = await self.obtener_datos_gs_smart(_url2);

                        data.forEach(function (f) {
                            let encontrado = 'undefined';
                            if (tipo == "I") {

                                encontrado = self.data_table_impo.filter(actual => actual.ws.equivalencia && actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO);
                                encontrado.forEach(function (R) {
                                    R.actual2020 = f;
                                });
                            }

                            if (tipo == "E") {
                                encontrado = self.data_table_expo.filter(actual => actual.ws.equivalencia && actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO);
                                encontrado.forEach(function (R) {
                                    R.actual2020 = f;
                                });
                            }

                            if (tipo == "ceI") {
                                encontrado = self.data_table_m_impo.filter(actual => actual.fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.nico == f.NICO);
                                encontrado.forEach(function (R) {
                                    R.actual2020 = f;
                                });
                            }

                        });

                        cadena_nueva = "";
                        cuenta += 1;
                        self.actualizaTabla = "tablaVS-" + cuenta;
                    }));
                    if (cuenta = arr_cadena.length) {
                        self.visible_download2 = true;
                        self.visible_download1 = true;

                        if (tipo == "I") {

                            self.data_table_impo = self.data_table_impo.sort(function (a, b) {
                                return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                            });
                        }
                        if (tipo == "E") {
                            self.data_table_expo = self.data_table_expo.sort(function (a, b) {
                                return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                            });
                        }
                        self.$root.$dialogLoader.hide();
                    }
                    return resolve(1);
                } catch (error) {
                    console.log("Error en llenar_nueva_tarifa_2020: ", error);
                    self.$root.$dialogLoader.hide();
                    return reject(0);
                }

            })

        },

        llenar_nueva_tarifa_2022:async function (records, tipo) {
            let self = this;
            return new Promise(async function (resolve, reject) {
                try {
                    console.log("iniciando 2022");
                    let contador1 = 0;
                    let cadena_nueva = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (tipo == "I" || tipo == "E") {
                            if (f.equivalencia.length > 0 && f.equivalencia[0] != undefined)
                                if (f.equivalencia[0].fraccion_enmienda != "" && f.equivalencia[0].nico != null)
                                    cadena_nueva += "%27" + f.equivalencia[0].fraccion_enmienda + f.equivalencia[0].nico + "%27,";

                            contador1 += 1;

                            if ((contador1 % 50 == 0) || records.length == contador1) {
                                cadena_nueva = cadena_nueva.slice(0, -1);
                                arr_cadena.push(cadena_nueva);
                                cadena_nueva = "";

                            }
                        }
                        if (tipo == "ceI" || tipo == "ceE") {
                            if (f.fraccion_enmienda.length > 0) {

                                if (f.fraccion_enmienda != "" && f.nico != null)
                                    cadena_nueva += "%27" + f.fraccion_enmienda + f.nico + "%27,";

                            }

                            contador1 += 1;

                            if ((contador1 % 50 == 0) || records.length == contador1) {
                                cadena_nueva = cadena_nueva.slice(0, -1);
                                arr_cadena.push(cadena_nueva);
                                cadena_nueva = "";

                            }
                        }

                    });
                    let cuenta = 0;
                    await Promise.all(arr_cadena.map(async (item) => {

                        //SE NUEVA TARIFA
                        let _url2 = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';
                        let data = await self.obtener_datos_gs_smart(_url2);

                        await data.forEach(function (f) {
                            let encontrado = 'undefined';
                            if (tipo == "I") {

                                encontrado = self.data_table_impo.filter(actual =>
                                    (actual.ws!="" && actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO)
                                    || (actual.ws2!="" && actual.ws2.equivalencia.length > 0 && actual.ws2.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws2.equivalencia[0].nico == f.NICO)
                                );
                                encontrado.forEach(function (R) {
                                    R.nueva = f;
                                });
                            }

                            if (tipo == "E") {
                                encontrado = self.data_table_expo.filter(actual =>
                                    (actual.ws!="" && actual.ws.equivalencia.length > 0 && actual.ws.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws.equivalencia[0].nico == f.NICO)
                                    || (actual.ws2!="" && actual.ws2.equivalencia.length > 0 && actual.ws2.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws2.equivalencia[0].nico == f.NICO)
                                );
                                encontrado.forEach(function (R) {
                                    R.nueva = f;
                                });
                            }

                            if (tipo == "ceI") {
                                encontrado = self.data_table_m_impo.filter(actual => actual.fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.nico == f.NICO);
                                encontrado.forEach(function (R) {
                                    R.nueva = f;
                                });
                            }

                        });

                        cadena_nueva = "";
                        cuenta += 1;
                        self.actualizaTabla = "tablaVS-" + cuenta;
                    }));
                    if (cuenta = arr_cadena.length) {
                        self.visible_download2 = true;
                        self.visible_download1 = true;

                        if (tipo == "I") {

                            self.data_table_impo = self.data_table_impo.sort(function (a, b) {
                                return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                            });

                        }
                        if (tipo == "E") {
                            self.data_table_expo = self.data_table_expo.sort(function (a, b) {
                                return a.ws.fraccion > b.ws.fraccion ? 1 : -1;
                            });

                        }

                        //self.$root.$dialogLoader.hide();
                    }
                    console.log("Terminando 2022");
                    return resolve(1);
                } catch (error) {
                    console.log("Error en llenar_nueva_tarifa_2022: ", error);
                    return reject(0);
                }

            })

        },
        llenar_tarifa_actual_2020: async function (records, tipo) {
            let self = this;
            return new Promise(async function (resolve, reject) {
                try {
                    let contador1 = 0;
                    let cadena = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (f.fraccion != "")
                            cadena += "%27" + f.fraccion + "%27,";

                        contador1 += 1;

                        if ((contador1 % 100 == 0) || records.length == contador1) {
                            cadena = cadena.slice(0, -1);
                            arr_cadena.push(cadena);
                            cadena = "";

                        }
                    });

                    await Promise.all(arr_cadena.map(async (item) => {

                        //SE OBTIENE TARIFA ACTUAL
                        let _url = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';

                        let data = await self.obtener_datos_gs_smart(_url);
                        data.forEach(function (f) {
                            let encontrado = undefined;
                            if (tipo == "I")
                                encontrado = self.data_table_impo.find(actual => actual.ws2.fraccion == f.Fraccion);
                            else
                                encontrado = self.data_table_expo.find(actual => actual.ws2.fraccion == f.Fraccion);

                            if (encontrado)
                                encontrado.actual2020 = f;
                        });
                    }));

                    //buscar los que no tienen datos en actual2020 y que si tiene ws2 y buscar usando el webservice
                    await Promise.all(self.data_table_impo.map(async (item) => {
                        if(item.ws2!="" && item.actual2020==""){
                            var search20 = "";
                            var url = "";

                            if(item.actual2020 == "" && item.ws2.nico){ //Si no se encontro buscamos agregandole el Nico
                                search20 = item.ws2.fraccion.replace(/\./g, '') + item.ws2.nico.toString();
                                url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                //console.log("search20: "+search20,url);
                                await self.obtener_datos_gs_smart(url).then(data => {
                                    //console.log("data: ",data);
                                    data.forEach(function (f) {
                                        item.actual2020 = f;
                                    });
                                });
                            }

                            if(item.actual2020 == ""){ //Si no se encontro en bFracciones, intentamos en bFracciones2
                                search20 = item.ws2.fraccion.replace(/\./g, '')
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.actual2020 = f;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.actual2020 = {};
                                            item.actual2020["Fraccion"] = item.ws2.fraccion;
                                            item.actual2020["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.actual2020 = {};
                                        item.actual2020["Fraccion"] = item.ws2.fraccion;
                                        item.actual2020["Descripcion"] = "No se encontró información";

                                    });

                            }

                            if(item.actual2020 == "" && item.ws2.nico){ //Si no se encontro en bFracciones, intentamos en bFracciones2 agregando Nico
                                search20 = item.ws2.fraccion.replace(/\./g, '') + item.ws2.nico.toString();
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.actual2020 = f;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.actual2020 = {};
                                            item.actual2020["Fraccion"] = item.ws2.fraccion;
                                            item.actual2020["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.actual2020 = {};
                                        item.actual2020["Fraccion"] = item.ws2.fraccion;
                                        item.actual2020["Descripcion"] = "No se encontró información";

                                    });
                            }

                            if(item.actual2020 == ""){
                                var search20 = item.ws2.fraccion.replace(/\./g, '');
                                //let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //let url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                var url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                await self.obtener_datos_gs_smart(url).then(data => {
                                        //console.log("data: ",data);
                                        data.forEach(function (f) {
                                            item.actual2020 = f;
                                        });
                                    });
                            }
                        }
                    }));
                    await Promise.all(self.data_table_expo.map(async (item) => {
                        if(item.ws2!="" && item.actual2020==""){
                            var search20 = "";
                            var url = "";
                            //Si no se encontro buscamos agregandole el Nico
                            if(item.ws2.nico){
                                search20 = item.ws2.fraccion.replace(/\./g, '') + item.ws2.nico.toString();
                                url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                //console.log("search20: "+search20,url);
                                await self.obtener_datos_gs_smart(url).then(data => {
                                    //console.log("data: ",data);
                                    data.forEach(function (f) {
                                        item.actual2020 = f;
                                        item.ws2.fraccion = search20;
                                    });
                                });
                            }


                            if(item.actual2020 == ""){ //Si no se encontro en bFracciones, intentamos en bFracciones2
                                search20 = item.ws2.fraccion.replace(/\./g, '')
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.actual2020 = f;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.actual2020 = {};
                                            item.actual2020["Fraccion"] = item.ws2.fraccion;
                                            item.actual2020["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.actual2020 = {};
                                        item.actual2020["Fraccion"] = item.ws2.fraccion;
                                        item.actual2020["Descripcion"] = "No se encontró información";

                                    });

                            }

                            if(item.actual2020 == "" && item.ws2.nico){ //Si no se encontro en bFracciones, intentamos en bFracciones2 agregando Nico
                                search20 = item.ws2.fraccion.replace(/\./g, '') + item.ws2.nico.toString();
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.actual2020 = f;
                                                item.ws2.fraccion = search20;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.actual2020 = {};
                                            item.actual2020["Fraccion"] = item.ws2.fraccion;
                                            item.actual2020["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.actual2020 = {};
                                        item.actual2020["Fraccion"] = item.ws2.fraccion;
                                        item.actual2020["Descripcion"] = "No se encontró información";

                                    });
                            }

                            if(item.actual2020 == ""){
                                search20 = item.ws2.fraccion.replace(/\./g, '');
                                //let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //let url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                await self.obtener_datos_gs_smart(url).then(data => {
                                        //console.log("data: ",data);
                                        data.forEach(function (f) {
                                            item.actual2020 = f;
                                        });
                                    });
                            }
                        }
                    }));

                    /*if (cuenta = arr_cadena.length) {
                        self.visible_download2 = true;
                        self.visible_download1 = true;
                        self.$root.$dialogLoader.hide();
                    }*/

                    return resolve(1);
                } catch (error) {
                    console.log("Error en llenar_tarifa_actual_2020: ", error);
                    return reject(0);
                }

            })

        },
        llenar_tarifa_actual_2020_EDITADO:async function (records, tipo) {
            let self = this;
            return new Promise(async function (resolve, reject) {
                try {
                    console.log("iniciando 2020");
                    let contador1 = 0;
                    let cadena = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (f.fraccion != "")
                            cadena += "%27" + f.fraccion + "%27,";

                        contador1 += 1;

                        if ((contador1 % 100 == 0) || records.length == contador1) {
                            cadena = cadena.slice(0, -1);
                            arr_cadena.push(cadena);
                            cadena = "";

                        }
                    });

                    await Promise.all(arr_cadena.map(async (item) => {
                        //SE OBTIENE TARIFA ACTUAL
                        let _url = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tableName=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';

                        let data = await self.obtener_datos_gs_smart(_url);
                        data.forEach(function (f) {
                            let encontrado = undefined;
                            if (tipo == "I")
                                encontrado = self.data_table_impo.find(actual => actual.ws2.fraccion == f.Fraccion);
                            else
                                encontrado = self.data_table_expo.find(actual => actual.ws2.fraccion == f.Fraccion);

                            if (encontrado)
                                encontrado.actual2020 = f;
                        });
                    }));

                    //buscar los que no tienen datos en actual2020 y que si tiene ws2 y buscar usando el webservice
                    await Promise.all(self.data_table_impo.map(async (item) => {
                        if(item.ws2!="" && item.actual2020==""){
                            var search20 = item.ws2.fraccion.replace(/\./g, '');
                            //let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion=" + search20 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                            let url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones&filterBy=FRACCION=" + search20 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                            await fetch(url)
                                .then(response => response.json())
                                .then(data => {
                                    var datos = data;
                                    if (data.length > 0)
                                        datos = data[0];

                                    try {
                                        if(datos.Fraccion && datos.Fraccion.length>0){
                                            var f = datos.Fraccion[0];
                                            item.actual2020 = f;
                                        }
                                    } catch (error) {
                                        //let x = "No se encontró la fraccion en la respuesta";
                                        item.actual2020 = {};
                                        item.actual2020["Fraccion"] = item.ws2.fraccion;
                                        item.actual2020["Descripcion"] = "No se encontró información";
                                    }

                                }).catch(function (error) {
                                    //console.log("No se obtuvo respuesta: ", error);
                                    item.actual2020 = {};
                                    item.actual2020["Fraccion"] = item.ws2.fraccion;
                                    item.actual2020["Descripcion"] = "No se encontró información";

                                });
                        }
                    }));
                    await Promise.all(self.data_table_expo.map(async (item) => {
                        if(item.ws2!="" && item.actual2020==""){
                            var search20 = item.ws2.fraccion.replace(/\./g, '');
                            //let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion=" + search20 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                            let url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones&filterBy=FRACCION=" + search20 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                            await fetch(url)
                                .then(response => response.json())
                                .then(data => {
                                    var datos = data;
                                    if (data.length > 0)
                                        datos = data[0];

                                    try {
                                        if(datos.Fraccion && datos.Fraccion.length>0){
                                            var f = datos.Fraccion[0];
                                            item.actual2020 = f;
                                        }
                                    } catch (error) {
                                        //let x = "No se encontró la fraccion en la respuesta";
                                        item.actual2020 = {};
                                        item.actual2020["Fraccion"] = item.ws2.fraccion;
                                        item.actual2020["Descripcion"] = "No se encontró información";
                                    }

                                }).catch(function (error) {
                                    //console.log("No se obtuvo respuesta: ", error);
                                    item.actual2020 = {};
                                    item.actual2020["Fraccion"] = item.ws2.fraccion;
                                    item.actual2020["Descripcion"] = "No se encontró información";

                                });
                        }
                    }));

                    console.log("Terminando 2020");
                    return resolve(1);
                } catch (error) {
                    console.log("Error en llenar_tarifa_actual_2020: ", error);
                    //this.$root.$dialogLoader.hide();
                    return reject(0);
                }

            })

        },
        llenar_tarifa_actual_2023:async function (records, tipo) {
            let self = this;
            return new Promise(async function (resolve, reject) {
                try {
                    console.log("iniciando 2023");
                    /*let contador1 = 0;
                    let cadena = "";
                    let cadena_nueva = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (tipo == "I" || tipo == "E") {
                            if (f.equivalencia && f.equivalencia.length > 0 && f.equivalencia[0] != undefined)
                                if (f.equivalencia[0].fraccion_enmienda != "" && f.equivalencia[0].nico != null)
                                    cadena_nueva += "%27" + f.equivalencia[0].fraccion_enmienda + f.equivalencia[0].nico + "%27,";

                            contador1 += 1;

                            if ((contador1 % 50 == 0) || records.length == contador1) {
                                cadena_nueva = cadena_nueva.slice(0, -1);
                                arr_cadena.push(cadena_nueva);
                                cadena_nueva = "";

                            }
                        }
                        if (tipo == "ceI" || tipo == "ceE") {
                            if (f.fraccion_enmienda.length > 0) {

                                if (f.fraccion_enmienda != "" && f.nico != null)
                                    cadena_nueva += "%27" + f.fraccion_enmienda + f.nico + "%27,";

                            }

                            contador1 += 1;

                            if ((contador1 % 50 == 0) || records.length == contador1) {
                                cadena_nueva = cadena_nueva.slice(0, -1);
                                arr_cadena.push(cadena_nueva);
                                cadena_nueva = "";

                            }
                        }
                    });

                    await Promise.all(arr_cadena.map(async (item) => {
                        //SE OBTIENE TARIFA ACTUAL
                        let _url = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tableName=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&orderBy=SYSID&startindex=1&endindex=100000000';

                        let data = await self.obtener_datos_gs_smart(_url);
                        data.forEach(function (f) {
                            let encontrado = [];
                            if (tipo == "I") {
                                try {
                                    encontrado = self.data_table_impo.filter(actual => actual.ws3 && actual.ws3.equivalencia.length > 0 && actual.ws3.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws3.equivalencia[0].nico == f.NICO);
                                } catch (error) {
                                    encontrado = [];
                                }
                                encontrado.forEach(function (R) {
                                    R.nueva = f;
                                });
                            }

                            if (tipo == "E") {
                                try {
                                    encontrado = self.data_table_impo.filter(actual => actual.ws3 && actual.ws3.equivalencia.length > 0 && actual.ws3.equivalencia[0].fraccion_enmienda == f.Fraccion.substring(0, 8) && actual.ws3.equivalencia[0].nico == f.NICO);
                                } catch (error) {
                                    encontrado = [];
                                }
                                encontrado.forEach(function (R) {
                                    R.nueva = f;
                                });
                            }
                        });
                    }));*/

                    let contador1 = 0;
                    let cadena = "";
                    let arr_cadena = [];
                    records.forEach(function (f) {

                        if (f.fraccion != "")
                            cadena += "%27" + f.fraccion + "%27,";

                        contador1 += 1;

                        if ((contador1 % 100 == 0) || records.length == contador1) {
                            cadena = cadena.slice(0, -1);
                            arr_cadena.push(cadena);
                            cadena = "";

                        }
                    });

                    await Promise.all(arr_cadena.map(async (item) => {

                        //SE OBTIENE TARIFA ACTUAL
                        let _url = 'https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion%20in%20(' + item + ')&startindex=1&endindex=100000000';

                        let data = await self.obtener_datos_gs_smart(_url);
                        data.forEach(function (f) {
                            let encontrado = undefined;
                            if (tipo == "I")
                                encontrado = self.data_table_impo.find(actual => actual.ws3.fraccion == f.Fraccion);
                            else
                                encontrado = self.data_table_expo.find(actual => actual.ws3.fraccion == f.Fraccion);

                            if (encontrado)
                                encontrado.nueva = f;
                        });
                    }));

                    //buscar los que no tienen datos en nueva y que si tiene ws3 y buscar usando el webservice
                    await Promise.all(self.data_table_impo.map(async (item) => {
                        if(item.ws3!="" && item.nueva==""){
                            var search20 = "";
                            var url = "";
                            //Si no se encontro buscamos agregandole el Nico
                            if(item.ws3.nico){
                                search20 = item.ws3.fraccion.replace(/\./g, '') + item.ws3.nico.toString();
                                url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                //console.log("search20: "+search20,url);
                                await self.obtener_datos_gs_smart(url).then(data => {
                                    //console.log("data: ",data);
                                    data.forEach(function (f) {
                                        item.nueva = f;
                                        item.ws3.fraccion = search20;
                                    });
                                });
                            }

                            if(item.nueva == ""){ //Si no se encontro en bFracciones, intentamos en bFracciones2
                                search20 = item.ws3.fraccion.replace(/\./g, '')
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.nueva = f;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.nueva = {};
                                            item.nueva["Fraccion"] = item.ws3.fraccion;
                                            item.nueva["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.nueva = {};
                                        item.nueva["Fraccion"] = item.ws3.fraccion;
                                        item.nueva["Descripcion"] = "No se encontró información";

                                    });

                            }

                            if(item.nueva == "" && item.ws3.nico){ //Si no se encontro en bFracciones, intentamos en bFracciones2 agregando Nico
                                search20 = item.ws3.fraccion.replace(/\./g, '') + item.ws3.nico.toString();
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.nueva = f;
                                                item.ws3.fraccion = search20;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.nueva = {};
                                            item.nueva["Fraccion"] = item.ws3.fraccion;
                                            item.nueva["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.nueva = {};
                                        item.nueva["Fraccion"] = item.ws3.fraccion;
                                        item.nueva["Descripcion"] = "No se encontró información";

                                    });
                            }

                            if(item.nueva == ""){
                                search20 = item.ws3.fraccion.replace(/\./g, '');
                                //url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                await self.obtener_datos_gs_smart(url).then(data => {
                                        //console.log("data: ",data);
                                        data.forEach(function (f) {
                                            item.nueva = f;
                                        });
                                    });
                            }
                        }
                    }));
                    await Promise.all(self.data_table_expo.map(async (item) => {
                        if(item.ws3!="" && item.nueva==""){
                            var search20 = "";
                            var url = "";
                            if(item.nueva == "" && item.ws3.nico){ //Si no se encontro buscamos agregandole el Nico
                                search20 = item.ws3.fraccion.replace(/\./g, '') + item.ws3.nico.toString();
                                url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                //console.log("search20: "+search20,url);
                                await self.obtener_datos_gs_smart(url).then(data => {
                                    //console.log("data: ",data);
                                    data.forEach(function (f) {
                                        item.nueva = f;
                                    });
                                });
                            }

                            if(item.nueva == ""){ //Si no se encontro en bFracciones, intentamos en bFracciones2
                                search20 = item.ws3.fraccion.replace(/\./g, '')
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.nueva = f;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.nueva = {};
                                            item.nueva["Fraccion"] = item.ws3.fraccion;
                                            item.nueva["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.nueva = {};
                                        item.nueva["Fraccion"] = item.ws3.fraccion;
                                        item.nueva["Descripcion"] = "No se encontró información";

                                    });

                            }

                            if(item.nueva == "" && item.ws3.nico){ //Si no se encontro en bFracciones, intentamos en bFracciones2 agregando Nico
                                search20 = item.ws3.fraccion.replace(/\./g, '') + item.ws3.nico.toString();
                                url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones2&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //console.log("search20: "+search20,url);
                                await fetch(url)
                                    .then(response => response.json())
                                    .then(data => {
                                        var datos = data;
                                        if (data.length > 0)
                                            datos = data[0];

                                        try {
                                            if(datos.FRACCION && datos.FRACCION.length>0){
                                                var f = {"Fraccion":datos.FRACCION,
                                                    "FraccionPunto": datos.FRACCIONPUNTO,
                                                    "NICO": datos.NICO,
                                                    "Descripcion": datos.DESCRIPCION,
                                                    "UMClave": datos.UMCLAVE,
                                                    "UMAbreviacion": datos.UMABREVIACION
                                                    };
                                                item.nueva = f;
                                            }
                                        } catch (error) {
                                            //let x = "No se encontró la fraccion en la respuesta";
                                            item.nueva = {};
                                            item.nueva["Fraccion"] = item.ws3.fraccion;
                                            item.nueva["Descripcion"] = "No se encontró información";
                                        }

                                    }).catch(function (error) {
                                        //console.log("No se obtuvo respuesta: ", error);
                                        item.nueva = {};
                                        item.nueva["Fraccion"] = item.ws3.fraccion;
                                        item.nueva["Descripcion"] = "No se encontró información";

                                    });
                            }

                            if(item.nueva == ""){
                                var search20 = item.ws3.fraccion.replace(/\./g, '');
                                //let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                //let url = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bFracciones&filterBy=FRACCION='" + search20 + "'&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";
                                var url = "https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=getdata&u=lourdes.aguilar@econnect.mx&p=12345678&tablename=bFracciones&queryfilters=Fraccion='" + search20 + "'&startindex=1&endindex=100000000";
                                await self.obtener_datos_gs_smart(url).then(data => {
                                        //console.log("data: ",data);
                                        data.forEach(function (f) {
                                            item.nueva = f;
                                        });
                                    });
                            }
                        }
                    }));

                    console.log("Terminando 2023");
                    return resolve(1);
                } catch (error) {
                    console.log("Error en llenar_tarifa_actual_2023: ", error);
                    //this.$root.$dialogLoader.hide();
                    return reject(0);
                }

            })

        },
        llenar_nueva_descripcion_partida: async function (records) {
            let self = this;
            var keys_data = {}; //Para guardar los 4 primeros de la fracción con su descripcion partida y no hacer tantas solicitudes

                for(var key in records){
                    var f = records[key];
                    if(f.fraccion){
                        var partida = f.fraccion.substring(0,4);

                        if(keys_data[partida]){
                            f["descripcion_partida"] = keys_data[partida];
                        } else {
                            var nueva_tabla22 = {};

                            var search22 = f.fraccion.replace(/\./g, '');

                            let url = "https://hts.gsmartcode.com/api/service?cmd=fracciondetails&fraccion=" + search22 + "&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963";

                            await fetch(url)
                                .then(response => response.json())
                                .then(function (data) {
                                    nueva_tabla22 = data;
                                    if (data.length > 0)
                                        nueva_tabla22 = data[0];

                                    if(nueva_tabla22.fracciones){
                                        for(var k in nueva_tabla22.fracciones){
                                            if(nueva_tabla22.fracciones[k].flen == 4){
                                                f["descripcion_partida"] = nueva_tabla22.fracciones[k].value;
                                                keys_data[partida] = nueva_tabla22.fracciones[k].value;
                                            }
                                        }
                                    }

                                })
                                .catch(err => {
                                    console.log("Error en descripcion_partida",err);
                                });
                        }
                    }

                }

        },
        get_fracciones_cliente() {
            this.model.rfc = this.$local_storage.get("rfc");

            let self = this;
            let data = {
                rfc: this.model.rfc,
                fecha_de: "2015-01-01",
                fecha_a: "2020-12-27"
            };

            axios.post(this.URL + "reportes/fracciones_equivalencia/", data)
                .then(async res => {
                    if (typeof res.data !== "undefined") {

                        if (res.data['importacion'].length > 0 || res.data['exportacion'].length > 0) {
                            for(var k in res.data["importacion"]){
                                this.lista_fracciones_cliente.push(res.data["importacion"][k].fraccion);
                            }
                            for(var k in res.data["exportacion"]){
                                this.lista_fracciones_cliente.push(res.data["importacion"][k].fraccion);
                            }

                        }
                    };
                })
                .catch(err => {
                    console.log(err);
                });
        },
        get_fracciones_cliente_22() {
            this.model.rfc = this.$local_storage.get("rfc");
            let self = this;
            let data = {
                rfc: this.model.rfc,
                fecha_de: "2020-12-27",
                fecha_a: moment().format("YYYY-MM-DD"),
            };

            axios.post(this.URL + "reportes/fracciones_equivalencia_2022/", data)
                .then(async res => {
                    if (typeof res.data !== "undefined") {

                        if (res.data['importacion'].length > 0 || res.data['exportacion'].length > 0) {
                            for(var k in res.data["importacion"]){
                                this.lista_fracciones_cliente_22.push(res.data["importacion"][k].fraccion);
                            }
                            for(var k in res.data["exportacion"]){
                                this.lista_fracciones_cliente_22.push(res.data["importacion"][k].fraccion);
                            }
                        }
                    };

                })
                .catch(err => {
                    console.log(err);
                });
        },
        async consulta_relacionadas() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.rfc = this.$local_storage.get("rfc");

            let self = this;
            let data = {
                rfc: this.model.rfc,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a
            };

            axios.post(this.URL + "reportes/fracciones_equivalencia/", data)
                .then(async res => {
                    if (typeof res.data !== "undefined") {

                        this.fracciones_cliente = res.data;

                        if (this.fracciones_cliente['importacion'].length > 0 || this.fracciones_cliente['exportacion'].length > 0) {
                            self.data_table_impo = [];
                            self.data_tarifa_actual = [];
                            self.data_nueva_tarifa = [];

                            //llenamos importaciones
                            let impos = this.fracciones_cliente['importacion'];
                            impos = impos.sort(function (a, b) {
                                return a.fraccion > b.fraccion ? 1 : -1;
                            });
                            await impos.forEach(function (f) {
                                if (f.equivalencia.length > 0)
                                    self.data_table_impo.push({
                                        ws: f,
                                        capitulo: f.equivalencia[0].capitulo,
                                        actual: "",
                                        nueva: ""
                                    });
                            });

                            await this.llenar_tarifa_actual(impos, 'I');
                            await this.llenar_nueva_tarifa(impos, 'I');

                            //llenamos exportaciones
                            let expos = this.fracciones_cliente['exportacion'];
                            expos = expos.sort(function (a, b) {
                                return a.fraccion > b.fraccion ? 1 : -1;
                            });
                            await expos.forEach(function (f) {
                                if (f.equivalencia.length > 0)
                                    self.data_table_expo.push({
                                        ws: f,
                                        capitulo: f.equivalencia[0].capitulo,
                                        actual: "",
                                        nueva: ""
                                    });
                            });
                            await this.llenar_tarifa_actual(expos, 'E');
                            await this.llenar_nueva_tarifa(expos, 'E');

                        } else {
                            self.$root.$dialogLoader.hide();
                        }
                    };

                })
                .catch(err => {
                    console.log(err);
                    self.$root.$dialogLoader.hide();
                }).then(() => {

                });
        },
        async consulta_relacionadas_22() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.rfc = this.$local_storage.get("rfc");

            let self = this;
            let data = {
                rfc: this.model.rfc,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a
            };

            axios.post(this.URL + "reportes/fracciones_equivalencia_2022/", data)
                .then(async res => {
                    if (typeof res.data !== "undefined") {

                        this.fracciones_cliente = res.data;

                        if (this.fracciones_cliente['importacion'].length > 0 || this.fracciones_cliente['exportacion'].length > 0) {
                            self.data_table_impo = [];
                            self.data_tarifa_actual = [];
                            self.data_nueva_tarifa = [];

                            //llenamos importaciones
                            let impos = this.fracciones_cliente['importacion'];
                            impos = impos.sort(function (a, b) {
                                return a.fraccion > b.fraccion ? 1 : -1;
                            });
                            await impos.forEach(function (f) {
                                if (f.equivalencia.length > 0)
                                    self.data_table_impo.push({
                                        ws: f,
                                        capitulo: f.equivalencia[0].capitulo,
                                        actual: "",
                                        nueva: ""
                                    });
                            });

                            await this.llenar_nueva_tarifa_20(impos, 'I');
                            await this.llenar_nueva_tarifa(impos, 'I');

                            //llenamos exportaciones
                            let expos = this.fracciones_cliente['exportacion'];
                            expos = expos.sort(function (a, b) {
                                return a.fraccion > b.fraccion ? 1 : -1;
                            });
                            await expos.forEach(function (f) {
                                if (f.equivalencia.length > 0)
                                    self.data_table_expo.push({
                                        ws: f,
                                        capitulo: f.equivalencia[0].capitulo,
                                        actual: "",
                                        nueva: ""
                                    });
                            });
                            await this.llenar_nueva_tarifa_20(expos, 'E');
                            await this.llenar_nueva_tarifa(expos, 'E');

                        } else {
                            self.$root.$dialogLoader.hide();
                        }
                    };

                })
                .catch(err => {
                    console.log(err);
                    self.$root.$dialogLoader.hide();
                }).then(() => {

                });
        },

        //Consulta 2012, 2020 y 2022, segun el rango de fechas
        async consulta_relacionadas_todas() {
            /**
                SFracciones tiene todas del 2012 al 27/12/2020
                bFracciones del 28/12/2020 al creo que 11/12/2022
                bFracciones las que estan ahorita vigente del 12/12/2022 al 2023
            */
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.rfc = this.$local_storage.get("rfc");
            self.data_table_impo = [];
            self.data_table_expo = [];

            let data = {
                rfc: this.model.rfc,
                fecha_de: this.model.fecha_de,
                fecha_a: "2020-12-27"
            };

            await axios.post(this.URL + "reportes/fracciones_equivalencia/", data)
                .then(async res => {

                    if (typeof res.data !== "undefined") {
                        this.fracciones_cliente = res.data;

                        if (res.data['importacion'].length > 0 || res.data['exportacion'].length > 0) {

                            //llenamos importaciones
                            let impos = res.data['importacion'];
                            impos = impos.sort(function (a, b) {
                                return a.fraccion > b.fraccion ? 1 : -1;
                            });
                            impos.forEach(function (f) {
                                if (f.equivalencia.length > 0)
                                    self.data_table_impo.push({
                                        ws: f,
                                        actual2012: "",
                                        //capitulo: f.equivalencia[0].capitulo,
                                        ws2:"",
                                        actual2020: "",
                                        ws3: "",
                                        nueva: ""
                                    });
                            });

                            await this.llenar_tarifa_actual_2012(impos, 'I');//Llena los actual2012
                            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                            await this.llenar_nueva_tarifa_2020(impos, 'I');//Llena los actual2020

                            //llenamos exportaciones
                            let expos = res.data['exportacion'];
                            expos = expos.sort(function (a, b) {
                                return a.fraccion > b.fraccion ? 1 : -1;
                            });
                            expos.forEach(function (f) {
                                if (f.equivalencia.length > 0)
                                    self.data_table_expo.push({
                                        ws: f,
                                        actual2012: "",
                                        //capitulo: f.equivalencia[0].capitulo,
                                        ws2:"",
                                        actual2020: "",
                                        ws3: "",
                                        nueva: ""
                                    });
                            });
                            await this.llenar_tarifa_actual_2012(expos, 'E');//Llena los actual2012
                            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                            await this.llenar_nueva_tarifa_2020(expos, 'E');//Llena los actual2020

                        }
                    }

                }).catch(err => {
                    console.log(err);
                    self.$root.$dialogLoader.hide();
                }).then(async () => {

                    //Si la fecha_a es mayor que 2020-12-27 se consulta 2020
                    if( moment(String(this.model.fecha_a)) > moment(String("2020-12-27")) ){
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        let data2 = {
                            rfc: this.model.rfc,
                            fecha_de: "2020-12-28",
                            fecha_a: "2022-12-11",
                        };
                        await axios.post(this.URL + "reportes/fracciones_equivalencia_2022_nico/", data2)
                        .then(async res2022 => {
                            if (typeof res2022.data !== "undefined") {
                                this.fracciones_cliente['importacion'] = this.fracciones_cliente['importacion'].concat(res2022.data['importacion']);
                                this.fracciones_cliente['exportacion'] = this.fracciones_cliente['exportacion'].concat(res2022.data['exportacion']);

                                var impos2 = [];
                                for(var k in res2022.data['importacion']){
                                    var f = res2022.data['importacion'][k];
                                    if(f.equivalencia.length > 0){
                                        for(var ke in f.equivalencia){//Agregamos un registro por cada equivalencia, Solicitó Humberto (07-jun-2023)
                                            var equiva = f.equivalencia[ke];
                                            impos2.push({"fraccion": f.fraccion, "nico":f.nico, equivalencia:[equiva]});
                                        }
                                    } else {
                                        impos2.push(f);
                                    }
                                }

                                var expos2 = [];
                                for(var k in res2022.data['exportacion']){
                                    var f = res2022.data['exportacion'][k];
                                    if(f.equivalencia.length > 0){
                                        for(var ke in f.equivalencia){//Agregamos un registro por cada equivalencia, Solicitó Humberto (07-jun-2023)
                                            var equiva = f.equivalencia[ke];
                                            expos2.push({"fraccion": f.fraccion, "nico":f.nico, equivalencia:[equiva]});
                                        }
                                    } else {
                                        expos2.push(f);
                                    }
                                }

                                if (impos2.length > 0 || expos2.length > 0) {
                                    var impos_2012 = self.data_table_impo.map(e => e.ws.fraccion);
                                    await impos2.forEach(function (f) {
                                        //if (f.equivalencia.length > 0)
                                        //if (!impos_2012.includes(f.fraccion))
                                            self.data_table_impo.push({
                                                ws: "",
                                                actual2012: "",
                                                //capitulo: f.equivalencia?f.equivalencia[0].capitulo:"",
                                                ws2: f,
                                                actual2020: "",
                                                ws3: "",
                                                nueva: ""
                                            });
                                    });

                                    //agregar los fracciones_equivalencias22
                                    //this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                                    await this.llenar_tarifa_actual_2020(impos2, 'I');//Llena los actual2020
                                    //this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                                    await this.llenar_nueva_tarifa_2022(impos2, 'I').then(result => {//Llena el nuevo 2022
                                        //console.log("self.data_table_impo: ",self.data_table_impo);
                                        //Quitamos vacíos
                                        /*self.data_table_impo = self.data_table_impo.filter(function(e){
                                            return e.actual2012!="" || e.actual2020!="" || e.nueva!="";
                                        });*/
                                    });


                                    //llenamos exportaciones
                                    var expos_2012 = self.data_table_expo.map(e => e.ws.fraccion);
                                    await expos2.forEach(function (f) {
                                        //if (f.equivalencia.length > 0)
                                        //if (!expos_2012.includes(f.fraccion))
                                            self.data_table_expo.push({
                                                ws: "",
                                                actual2012: "",
                                                //capitulo: f.equivalencia?f.equivalencia[0].capitulo:"",
                                                ws2:f,
                                                actual2020: "",
                                                ws3: "",
                                                nueva: ""
                                            });
                                    });

                                    //agregar los fracciones_equivalencias22
                                    //this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                                    await this.llenar_tarifa_actual_2020(expos2, 'E');//Llena los actual2020
                                    //this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                                    await this.llenar_nueva_tarifa_2022(expos2, 'E').then(result => {//Llena el nuevo 2022
                                        //console.log("self.data_table_expo: ",self.data_table_expo);
                                        //Quitamos vacíos
                                        /*self.data_table_expo = self.data_table_expo.filter(function(e){
                                            return e.actual2012!="" || e.actual2020!="" || e.nueva!="";
                                        });*/
                                    });
                                }
                            }
                        }).catch(err => {
                            console.log(err);
                            self.$root.$dialogLoader.hide();
                        }).then(()=>{
                            self.$root.$dialogLoader.hide();
                        });
                    }

                    //Si la fecha_a es mayor que 2022-12-11 se consulta 2022 -> 2023
                    if( moment(String(this.model.fecha_a)) > moment(String("2022-12-11")) ){
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        let data3 = {
                            rfc: this.model.rfc,
                            fecha_de: "2022-12-12",
                            fecha_a: this.model.fecha_a,
                        };
                        await axios.post(this.URL + "reportes/fracciones_equivalencia_2022_nico/", data3)
                        .then(async res2023 => {
                            if (typeof res2023.data !== "undefined") {
                                this.fracciones_cliente['importacion'] = this.fracciones_cliente['importacion'].concat(res2023.data['importacion']);
                                this.fracciones_cliente['exportacion'] = this.fracciones_cliente['exportacion'].concat(res2023.data['exportacion']);

                                let impos3 = res2023.data['importacion'];
                                let expos3 = res2023.data['exportacion'];

                                if (impos3.length > 0 || expos3.length > 0) {
                                    var impos_2020 = self.data_table_impo.map(e => e.ws2.fraccion);
                                    await impos3.forEach(function (f) {
                                        //if (f.equivalencia.length > 0)
                                        //if (!impos_2020.includes(f.fraccion))
                                            self.data_table_impo.push({
                                                ws: "",
                                                actual2012: "",
                                                //capitulo: f.equivalencia?f.equivalencia[0].capitulo:"",
                                                ws2: "",
                                                actual2020: "",
                                                ws3: f,
                                                nueva: ""
                                            });
                                    });

                                    await this.llenar_tarifa_actual_2023(impos3, 'I').then(result =>{
                                        self.data_table_impo = self.eliminarDuplicados(self.data_table_impo);
                                    });//Llena los nueva 2023

                                    //llenamos exportaciones
                                    var expos_2020 = self.data_table_expo.map(e => e.ws2.fraccion);
                                    await expos3.forEach(function (f) {
                                        //if (f.equivalencia.length > 0)
                                        //if (!expos_2020.includes(f.fraccion))
                                            self.data_table_expo.push({
                                                ws: "",
                                                actual2012: "",
                                                //capitulo: f.equivalencia?f.equivalencia[0].capitulo:"",
                                                ws2:"",
                                                actual2020: "",
                                                ws3:f,
                                                nueva: ""
                                            });
                                    });

                                    await this.llenar_tarifa_actual_2023(expos3, 'E').then(result =>{
                                        self.data_table_expo = self.eliminarDuplicados(self.data_table_expo);
                                    });//Llena los nueva -2023
                                }
                            }
                        }).catch(err => {
                            console.log(err);
                            self.$root.$dialogLoader.hide();
                        }).then(()=>{
                            self.$root.$dialogLoader.hide();
                        });
                    }

                });
        },

        async consulta_nicos() {
            if(this.$refs.reportes_form.validate()){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.rfc = this.$local_storage.get("rfc");

            let self = this;
            let data = {
                capitulo: self.model.capitulo,
                simple: true
            };

            await axios.post(this.URL + "reportes/fracciones_capitulo/", data)
                .then(async res => {
                    if (typeof res.data !== "undefined") {
                        if(self.model.opcion == 'fracciones'){
                            var filtro = res.data.filter(function(e){
                                return (e.fraccion!=null && self.lista_fracciones_cliente.includes(e.fraccion));
                            });
                        } else {
                            var filtro = res.data;
                        }


                        this.fracciones_cliente = filtro;
                        if (this.fracciones_cliente.length > 0) {
                            self.data_table_m_impo = filtro;
                            let aux = [];
                            await self.data_table_m_impo.forEach(function (f) {
                                if (f.fraccion != null) {
                                    f.capitulo2 = f.capitulo;
                                    f.fraccion_enmienda2 = f.fraccion_enmienda;
                                } else {
                                    f.capitulo2 = '';
                                    f.fraccion_enmienda2 = '';
                                }

                                aux.push(f);
                            });
                            self.data_table_m_impo = aux;

                            await this.llenar_nueva_tarifa(self.data_table_m_impo, 'ceI');
                            //(02-05-2023): Solicitaron agregar la columna de descripción partida que viene en facciones cuando flen=4 por ejemplo 39.15 -> Desechos, desperdicios y recortes, de plástico.
                            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                            await this.llenar_nueva_descripcion_partida(self.data_table_m_impo);
                            self.filtrados = self.data_table_m_impo;
                            self.$root.$dialogLoader.hide();
                        } else {
                            self.$root.$dialogLoader.hide();
                        }

                    };

                })
                .catch(err => {
                    console.log(err);
                    self.$root.$dialogLoader.hide();
                }).then(() => {

                });
            }

        },
        async consulta_nicos_2022() {
            if(this.$refs.reportes_form.validate()){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.rfc = this.$local_storage.get("rfc");

            let self = this;
            let data = {
                capitulo: self.model.capitulo,
                simple: true
            };

            await axios.post(this.URL + "reportes/fracciones_capitulo_2022/", data)
                .then(async res => {
                    if (typeof res.data !== "undefined") {
                        if(self.model.opcion == 'fracciones'){
                            var filtro = res.data.filter(function(e){
                                return (e.fraccion!=null && self.lista_fracciones_cliente_22.includes(e.fraccion));
                            });
                        } else {
                            var filtro = res.data;
                        }

                        this.fracciones_cliente = filtro;
                        if (this.fracciones_cliente.length > 0) {
                            self.data_table_m_impo = filtro;
                            let aux = [];
                            await self.data_table_m_impo.forEach(function (f) {
                                if (f.fraccion != null) {
                                    f.capitulo2 = f.capitulo;
                                    f.fraccion_enmienda2 = f.fraccion_enmienda;
                                } else {
                                    f.capitulo2 = '';
                                    f.fraccion_enmienda2 = '';
                                }

                                aux.push(f);
                            });
                            self.data_table_m_impo = aux;

                            await this.llenar_nueva_tarifa(self.data_table_m_impo, 'ceI');
                            //(02-05-2023): Solicitaron agregar la columna de descripción partida que viene en facciones cuando flen=4 por ejemplo 39.15 -> Desechos, desperdicios y recortes, de plástico.
                            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                            await this.llenar_nueva_descripcion_partida(self.data_table_m_impo);
                            self.filtrados = self.data_table_m_impo;

                            self.$root.$dialogLoader.hide();
                        } else {
                            self.$root.$dialogLoader.hide();
                        }

                    };

                })
                .catch(err => {
                    console.log(err);
                    self.$root.$dialogLoader.hide();
                }).then(() => {

                });
            }

        },

        generaPDF: function (fraccion) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let html = document.getElementById("detalleFraccion");

            var opt = {
                margin: [1, 0.5, 1, 0.5], //top, left, bottom, right
                filename: "Tigie-" + fraccion + ".pdf",
                image: {
                    type: "jpeg",
                    quality: 0.5
                },
                html2canvas: {
                    scale: 2
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait"
                }
            };
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .toPdf().get('pdf')
                .then(function (pdf) {
                    var totalPages = pdf.internal.getNumberOfPages();

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text("Detalle de la fracción arancelaria " + fraccion, pdf.internal.pageSize.getWidth() - 3.2, .8);
                        pdf.text('_________________________________________________________________________________________________',
                            .5, .85);
                        pdf.text("" + i, pdf.internal.pageSize.getWidth() - .6, pdf.internal.pageSize.getHeight() - 1.1);
                    }
                    thisObj.$root.$dialogLoader.hide();
                })
                .save();

        },

        obtenerNuevaTabla: function (tabla, fraccion) {
            let self = this;
            let _url2 = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=" + tabla + "&filterBy=FRACCION%20in%20(%27" + fraccion + "%27)&orderBy=&startIndex=1&endIndex=12&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=";
            fetch(_url2)
                .then(response => response.json())
                .then(function (data) {
                    self.nueva_tabla[tabla] = data;
                    if (data.length > 0)
                        self.ws_columnas_nueva_tabla[tabla] = Object.keys(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        obtenerNuevaTablaNICO: function (tabla, fraccion) {
            let self = this;
            let f = fraccion;
            // let n = fraccion.substr(8, 2);
            let _url2 = "";
            if (tabla == 'bIEPS')
                _url2 = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=" + tabla + "&filterBy=FRACCIONSINPUNTO%20LIKE%20'" + f + "%25'&orderBy=&startIndex=1&endIndex=1&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=";
            else
                _url2 = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=" + tabla + "&filterBy=FRACCION%20LIKE%20'" + f + "%25'&orderBy=&startIndex=1&endIndex=1&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=";

            fetch(_url2)
                .then(response => response.json())
                .then(function (data) {
                    self.nueva_tabla[tabla] = data;
                    if (data.length > 0)
                        self.ws_columnas_nueva_tabla[tabla] = Object.keys(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });

        },

        consultaNotas: function () {
            let self = this;

            this.search20 = "";
            let _url2 = "https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bNotasNacionales&filterBy=Capitulo=%27" + self.capituloNota + "%27&orderBy=&startIndex=1&endIndex=12&formatResult=JSON&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=";

            fetch(_url2)
                .then(response => response.json())
                .then(function (data) {
                    self.datosCapituloNota = data;
                    if (data.length > 0)
                        self.columnasCapituloNota = Object.keys(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });

        },
        getfile(dir) {
            if (dir != null) {
                return "https://hts.gsmartcode.com/" + dir.replace(/\\/g, "/");
            } else {
                return "";
            }
        },
        getTigies: function () {
            var f = new Date();

            let y = f.getFullYear();
            let m = f.getMonth() + 1;
            let d = f.getDate();

            if (m < 10)
                m = '0' + m;
            if (d < 10)
                d = '0' + d;

            let hoy = y + m + d;

            let self = this;
            fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'" + hoy + "'%20and%20'" + hoy + "'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
                .then(response => response.json())
                .then(data => {
                    //console.log(data);

                    data.forEach(function (p) {

                        let fecha = self.arreglaMes(p.Fecha.substring(0, p.Fecha.length - 8));
                        let link = "<a target='_blank' title='Visualizar PDF' href='https://hts.gsmartcode.com/docs/bitacora/" + p.SYSID + ".pdf'> <i class='v-icon notranslate mdi mdi-file' /></a>";
                        let mas = "<br/><a href='/DOF'>Ver Mas..</a>"
                        if (p.Publicacion != "Sin publicación en el DOF el dia hoy, relacionada con la TIGIE.")
                            self.$toast.info(p.Publicacion + mas, "DOF - " + fecha + " - Secretaría " + p.Secretaria + link, {
                                balloon: true,
                                close: true,
                                position: "bottomLeft",
                                timeout: 10000,
                                animateInside: true,
                                drag: true,
                                transitionIn: 'flipInX',
                                transitionOut: 'flipOutX',
                                pauseOnHover: true
                            });
                    });

                }).catch(function (error) {
                    console.log(error);
                });

        },

    }
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: bold;

}

.divisor {
    background-color: #df7205;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

.VueTables>>>thead th {
    white-space: normal !important;
}

.VueTables>>>tbody td {
    white-space: normal !important;
}

.footer-hide>>>.VuePagination {
    display: none;
}

.notas {
    -ms-word-break: break-all;
    word-break: break-all;

    /* Non standard for webkit */
    word-break: break-word;

    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
}
</style>
